import { t as be } from "./module.esm-CPdxcUov.js";
import { n as br, t as ke } from "./morphNodes-BUJqEfyn.js";
import { t as yr } from "./queueBounce-CVV88D_L.js";
var wr = {
  "x-transition:enter": "transition-opacity ease-linear duration-300",
  "x-transition:enter-start": "opacity-0",
  "x-transition:enter-end": "opacity-100",
  "x-transition:leave": "transition-opacity ease-linear duration-300",
  "x-transition:leave-start": "opacity-100",
  "x-transition:leave-end": "opacity-0"
}, jt = {
  "x-transition:enter": "transition ease-in-out duration-300 transform",
  "x-transition:enter-start": "-translate-x-full",
  "x-transition:enter-end": "translate-x-0",
  "x-transition:leave": "transition ease-in-out duration-300 transform",
  "x-transition:leave-start": "translate-x-0",
  "x-transition:leave-end": "-translate-x-full"
}, xr = (e) => e.data("addressSwitch", ({ addresses: t }) => ({
  addresses: t,
  slideTransition: jt,
  visibleForm: !1,
  currentlyEditedAddress: null,
  showForm() {
    this.visibleForm = !0;
  },
  editAddress(r) {
    this.visibleForm = !0, this.currentlyEditedAddress = this.addresses.find((n) => n.id === r), this.scrollFormIntoView();
  },
  cancelEdit() {
    this.visibleForm = !1, this.currentlyEditedAddress = null, this.scrollFormIntoView();
  },
  scrollFormIntoView() {
    window.matchMedia("(max-width: 1023px)").matches && document.querySelector(".address-form")?.scrollIntoView({ behavior: "smooth" });
  }
})), Er = (e) => e.data("announcement", (t) => {
  const { settings: r } = t;
  return {
    current: 0,
    init() {
      r.auto_scroll && t.count > 0 && this.autoScroll(), this.$watch("current", (n) => this.autoScroll(n));
    },
    change(n) {
      this.current = n;
    },
    autoScroll(n = 0) {
      n >= t.count ? n = 0 : n += 1, setTimeout(() => this.change(n), r.delay * 1e3);
    },
    scrollThrough() {
      return {
        "x-transition:enter": "transition ease-in-out duration-300 transform absolute delay-300",
        "x-transition:enter-start": "-translate-y-full opacity-0",
        "x-transition:enter-end": "translate-y-0",
        "x-transition:leave": "transition ease-in-out duration-300 transform absolute",
        "x-transition:leave-start": "translate-y-0",
        "x-transition:leave-end": "translate-y-full opacity-0 "
      };
    }
  };
}), Sr = (e) => {
  e.data("backInStock", (t, r) => ({
    open: !1,
    sending: !1,
    sent: !1,
    query: {
      a: "Mtd5NY",
      g: "",
      email: "",
      variant: r,
      product: t,
      platform: "shopify",
      subscribe_for_newsletter: !1
    },
    get emailIsValid() {
      return /.+@.+\..+/.test(this.query.email);
    },
    get buttonLabel() {
      return this.sending ? "Sending..." : this.sent ? "Sent!" : "Notify Me When Available";
    },
    async submit() {
      if (!this.query.email) return;
      const n = "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", i = {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(this.query)
      };
      this.sending = !0;
      try {
        const a = await fetch(n, i);
        if (!a.ok) throw new Error("Failed to subscribe");
        if (!(await a.json()).success) throw new Error("Failed to subscribe");
      } catch (a) {
        console.error(a);
      }
      this.sending = !1, this.sent = !0, setTimeout(() => this.open = !1, 2e3);
    }
  }));
}, Tr = (e) => {
  const t = {
    id: Number(e.get("id")),
    quantity: Number(e.get("quantity") ?? 1),
    properties: {}
  };
  for (const [r, n] of e.entries())
    if (r === "selling_plan" && n && (t.selling_plan = Number(n)), r.startsWith("properties")) {
      const i = r.match(/\[(.*)\]/)?.[1];
      i && (t.properties[i] = String(n).replace("Offset ", ""));
    }
  return t;
}, ye = /* @__PURE__ */ (function(e) {
  return e.ADD = "cart/add.js", e.CHANGE = "cart/change.js", e.CLEAR = "cart/clear.js", e.UPDATE = "cart/update.js", e.GET = "cart.js", e;
})({}), ot = (e, t) => t instanceof e ? t : null, kr = (e, t, r = 0) => Math.min(Math.max(e, r), t), xe = {}, Nr = async (e) => {
  const t = e.toString();
  if (xe[t]) return xe[t];
  const r = await fetch(e);
  return r.ok ? (xe[t] = await r.text(), xe[t]) : null;
}, Or = () => new Promise((e) => queueMicrotask(() => setTimeout(e, 0))), Cr = (e, t, r = 0) => (e - r) % (t - r) + r, Bt = class Ht {
  val;
  constructor(t) {
    this.val = t;
  }
  isSome() {
    return !0;
  }
  isNone() {
    return !1;
  }
  unwrap() {
    return this.val;
  }
  unwrapOr(t) {
    return this.val;
  }
  unwrapOrElse(t) {
    return this.val;
  }
  expect(t) {
    return this.val;
  }
  andThen(t) {
    return t(this.val);
  }
  orElse() {
    return this;
  }
  map(t) {
    return new Ht(t(this.val));
  }
  mapOr(t, r) {
    return t(this.val);
  }
  mapOrElse(t, r) {
    return t(this.val);
  }
  flatten() {
    return _r(this.val) ? this.val : this;
  }
  inspect(t) {
    return t === 2 ? this : (t(this.val), this);
  }
  okOr(t) {
    return new Qe(this.val);
  }
}, qt = class {
  val = null;
  isSome() {
    return !1;
  }
  isNone() {
    return !0;
  }
  unwrap() {
    throw new Error("called `Option.unwrap()` on a `None` value");
  }
  unwrapOr(e) {
    return e;
  }
  unwrapOrElse(e) {
    return e();
  }
  expect(e) {
    throw new Error(`Error unwrapping None. Expected ${e}`);
  }
  andThen() {
    return this;
  }
  orElse(e) {
    return e();
  }
  map(e) {
    return this;
  }
  mapOr(e, t) {
    return t;
  }
  mapOrElse(e, t) {
    return t();
  }
  flatten() {
    return this;
  }
  inspect() {
    return this;
  }
  okOr(e) {
    return new _e(e);
  }
}, _r = (e) => e instanceof Bt || e instanceof qt, Ar = new qt(), Fr = /* @__PURE__ */ Symbol(), Ir = /* @__PURE__ */ Symbol(), Qe = class Vt {
  is = Fr;
  value;
  constructor(t) {
    this.value = t;
  }
  isOk() {
    return !0;
  }
  isErr() {
    return !1;
  }
  unwrap() {
    return this.value;
  }
  unwrapOr(t) {
    return this.value;
  }
  unwrapOrElse(t) {
    return this.value;
  }
  unwrapErr() {
    throw new Error("called `Result.unwrapErr()` on an `Ok` value");
  }
  expect(t) {
    return this.value;
  }
  andThen(t) {
    return t(this.value);
  }
  orElse() {
    return this;
  }
  map(t) {
    return new Vt(t(this.value));
  }
  mapErr() {
    return this;
  }
  mapOr(t, r) {
    return t(this.value);
  }
  mapOrElse(t, r) {
    return t(this.value);
  }
  inspect(t) {
    return t === 2 ? this.value : (t(this.value), this);
  }
  inspectErr() {
    return this;
  }
  ok() {
    return new Bt(this.value);
  }
  flatten() {
    const t = this.value;
    return Lr(t) ? t : this;
  }
}, _e = class Ut {
  is = Ir;
  error;
  constructor(t) {
    this.error = t;
  }
  isOk() {
    return !1;
  }
  isErr() {
    return !0;
  }
  unwrap() {
    throw this.error;
  }
  unwrapOr(t) {
    return t;
  }
  unwrapOrElse(t) {
    return t(this.error);
  }
  unwrapErr() {
    return this.error;
  }
  expect(t) {
    throw new Error(`Error unwrapping Err value: ${this.error}. Expected ${t}`);
  }
  andThen() {
    return this;
  }
  orElse(t) {
    return t(this.error);
  }
  map() {
    return this;
  }
  mapErr(t) {
    return new Ut(t(this.error));
  }
  mapOr(t, r) {
    return r;
  }
  mapOrElse(t, r) {
    return r(this.error);
  }
  inspect(t) {
    return t === 2 ? this.error : this;
  }
  inspectErr(t) {
    return t(this.error), this;
  }
  ok() {
    return Ar;
  }
  flatten() {
    return this;
  }
}, Lr = (e) => e instanceof Qe || e instanceof _e, st = class extends Error {
  retry = !1;
  fullPull = !1;
  constructor(e) {
    super(e.message, { cause: e }), e.status === zt.UnprocessableEntity && (this.fullPull = !0);
  }
}, zt = /* @__PURE__ */ (function(e) {
  return e[e.Unknown = 0] = "Unknown", e[e.VariantNotFound = 404] = "VariantNotFound", e[e.UnprocessableEntity = 422] = "UnprocessableEntity", e;
})({});
async function je(e, t) {
  const r = new URL(window.Shopify.routes.root + e, window.location.origin);
  try {
    const n = await fetch(r, {
      method: e === ye.GET ? "GET" : "POST",
      headers: { "Content-Type": "application/json" },
      body: t ? JSON.stringify(t) : void 0
    });
    return n.ok ? new Qe(await n.json()) : new _e(new st(await n.json()));
  } catch (n) {
    return new _e(new st({
      status: zt.Unknown,
      message: "An Unknown error Occured with a request to Shopify",
      description: n instanceof Error ? n.message : `Sending a request to ${e} with payload ${t} failed.`
    }));
  }
}
var ct = (e) => {
  const t = Rr(e);
  return je(ye.ADD, t);
}, Rr = (e) => ({ items: br(e).map((t) => typeof t == "object" ? {
  quantity: 1,
  ...t,
  properties: Object.assign({}, t.properties ?? {})
} : {
  id: t,
  quantity: 1,
  properties: {}
}) }), Dr = (e) => je(ye.CHANGE, e), $r = () => je(ye.GET), Pr = (e) => {
  const t = { updates: e };
  return je(ye.UPDATE, t);
}, Mr = (e) => {
  let t = 0;
  const r = new EventTarget();
  e.store("cart", {
    name: "cart",
    section: "cart-drawer",
    isOpen: new URLSearchParams(location.search).get("cart") === "true",
    updating: !0,
    data: JSON.parse(document.querySelector("script#cart-data")?.textContent ?? "{}"),
    items: [],
    get totalItems() {
      return this.items.reduce((n, i) => n + i.quantity, 0);
    },
    get totalPrice() {
      return this.data.total_price;
    },
    init() {
      this.items = this.data.items, window.addEventListener("rebuy.beforeAdd", () => this.updating = !0), window.addEventListener("rebuy.add", () => this.update(async () => this.data = await this.getState())), r.dispatchEvent(new Event("init")), this.updating = !1;
    },
    async update(n) {
      r.dispatchEvent(new Event("update"));
      try {
        this.updating = !0, t++;
        const i = await n();
        return t && t--, t || (this.updating = !1, e.nextTick(() => this.items = this.data.items)), i;
      } catch (i) {
        return console.error(i), this.data = await this.getState(), this.updating = !1, e.nextTick(() => {
          this.items = this.data.items;
        }), this.data;
      }
    },
    toggle() {
      this.isOpen ? this.open() : this.close();
    },
    open() {
      this.isOpen || (this.isOpen = !0, r.dispatchEvent(new Event("open")));
    },
    close() {
      this.isOpen && (this.isOpen = !1, r.dispatchEvent(new Event("close")));
    },
    load() {
      r.dispatchEvent(new Event("load"));
    },
    handleError(n) {
      r.dispatchEvent(new CustomEvent("error", { detail: n.cause.message }));
    },
    async getState() {
      const n = (await $r()).inspectErr(this.handleError).unwrapOr(this.data);
      return queueMicrotask(this.load), n;
    },
    async addItem(n) {
      await this.update(async () => {
        (await ct(n)).inspectErr(this.handleError), this.data = await this.getState();
      });
    },
    async removeItem(n) {
      await this.update(async () => {
        (await Pr({ [n]: 0 })).inspectErr(this.handleError), this.data = await this.getState();
      });
    },
    async updateItem(n, i) {
      await this.update(async () => {
        (await Dr({
          id: n,
          ...i
        })).inspectErr(this.handleError), this.data = await this.getState();
      });
    },
    async addFromForm(n) {
      await this.update(async () => {
        const i = n instanceof HTMLFormElement ? [n] : document.querySelectorAll((n.startsWith("form") ? "" : n.startsWith("#") ? "form" : "form#") + n);
        try {
          (await ct(Array.prototype.map.call(i, (a) => (console.assert(a.reportValidity(), "Form is invalid"), Tr(new FormData(a)))).filter(Boolean))).inspectErr(this.handleError).unwrap(), this.data = await this.getState();
        } catch (a) {
          console.error(a);
        }
      }), this.open(), await this.update(async () => this.data = await this.getState()), e.nextTick(() => this.open());
    },
    addEventListener(n, i) {
      r.addEventListener(n, i);
    },
    removeEventListener(n, i) {
      r.removeEventListener(n, i);
    },
    dispatchEvent(n) {
      return r.dispatchEvent(n);
    }
  });
}, jr = window?.Shopify?.currency ?? {
  active: "USD",
  rate: 1
}, lt = `${window?.Shopify?.locale ?? "en"}-${window?.Shopify?.country ?? "US"}`, et = (e, t = lt, r = {}) => new Intl.NumberFormat(t || lt, {
  style: "currency",
  currency: jr.active,
  currencyDisplay: "narrowSymbol",
  ...r
}).format(Number(e)), Br = (e) => e.data("cartDrawer", () => ({
  init() {
    this.refresh = this.refresh.bind(this), this.updateItem = e.debounce(this.updateItem.bind(this), 500), this.$store.cart.addEventListener("open", this.refresh);
  },
  destroy() {
    this.$store.cart.removeEventListener("open", this.refresh);
  },
  async refresh() {
    const t = new URL(window.location.href), r = Ge();
    t.searchParams.set("sections", r.join(","));
    const n = await fetch(t);
    if (r.length) {
      const i = await n.json();
      ke(Object.values(i).join(""), []);
    }
  },
  close() {
    this.$store.cart.close();
  },
  async removeItem(t) {
    const r = { [t]: 0 }, n = Ge(), i = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        updates: r,
        sections: n.join(",")
      })
    });
    if (n.length) {
      const a = await i.json();
      ke(Object.values(a.sections).join(""), []);
    }
  },
  async updateItem(t, r) {
    const n = { [t]: r }, i = Ge(), a = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        updates: n,
        sections: i.join(",")
      })
    });
    if (i.length) {
      const o = await a.json();
      ke(Object.values(o.sections).join(""), []);
    }
  },
  formatMoney: et
})), Ge = () => {
  const e = Array.from(document.querySelectorAll(".shopify-section:has([data-oob-swap])"), (t) => t?.id.replace("shopify-section-", "") ?? "");
  return Array.from(new Set(e));
}, Hr = (e) => e.data("collectionFilters", (t) => ({
  ...t,
  open: !1,
  fadeTransition: {
    "x-transition:enter": "transition-opacity ease-linear duration-300",
    "x-transition:enter-start": "opacity-0",
    "x-transition:enter-end": "opacity-100",
    "x-transition:leave": "transition-opacity ease-linear duration-300",
    "x-transition:leave-start": "opacity-100",
    "x-transition:leave-end": "opacity-0"
  },
  slideTransition: {
    "x-transition:enter": "transition ease-in-out duration-300 transform",
    "x-transition:enter-start": "-translate-x-full",
    "x-transition:enter-end": "translate-x-0",
    "x-transition:leave": "transition ease-in-out duration-300 transform",
    "x-transition:leave-start": "translate-x-0",
    "x-transition:leave-end": "-translate-x-full"
  }
})), qr = (e) => e.data("detailsElement", () => ({
  isOpen: !1,
  theDetails: null,
  summaryElement: null,
  init() {
    this.summaryElement = this.$el.querySelector("summary"), this.summaryElement.setAttribute("aria-expanded", !1), this.summaryElement.setAttribute("aria-controls", this.$refs.contentElement.id), this.theDetails = this.$el, this.$watch("$store.mobileMenu.visible", (t) => !t && this.close());
  },
  open() {
    this.summaryElement.setAttribute("aria-expanded", !0), this.$nextTick(() => {
      this.isOpen = !0;
    });
  },
  cleanUp() {
    setTimeout(() => {
      this.theDetails.removeAttribute("open").then(() => this.isOpen = !1);
    }, 200);
  },
  close() {
    this.isOpen = !1, this.summaryElement.setAttribute("aria-expanded", !1), setTimeout(() => {
      this.theDetails.removeAttribute("open");
    }, 300);
  },
  detailsContent: {
    "x-show"() {
      return this.isOpen;
    },
    "x-transition:enter": "transition-transform",
    "x-transition:enter-start": "translate-x-full",
    "x-transition:leave": "transition-transform",
    "x-transition:leave-end": "translate-x-full"
  }
})), Vr = (e) => e == null ? [] : Array.isArray(e) ? e.map((t) => Number(t)) : typeof e == "number" && !Number.isNaN(e) ? [e] : typeof e == "string" ? e.split(",").map((t) => t.trim()).filter(Boolean).map((t) => Number(t)) : [], Ur = (e) => e ? Array.isArray(e) ? e.map(String) : typeof e == "string" ? e.split(",").map((t) => t.trim()).filter(Boolean) : [] : [], zr = (e) => e ? typeof e == "string" ? e : String(e) : "", Ee = (e) => {
  const t = e ?? {};
  let r = Number(t.cutOffHour);
  Number.isFinite(r) || (r = 14);
  let n = Number(t.leadTime);
  return Number.isFinite(n) || (n = 0), {
    cutOffHour: r,
    leadTime: n,
    messageHtml: zr(t.messageHtml),
    isCustomMessage: !!t.isCustomMessage,
    restrictedDays: Vr(t.restrictedDays),
    restrictedDates: Ur(t.restrictedDates)
  };
}, ut = (e) => e.dayOfWeek % 7, Wr = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
], Kr = (e) => {
  let t = Math.max(0, Math.floor(e));
  const r = Math.floor(t / 86400);
  t %= 86400;
  const n = Math.floor(t / 3600);
  return t %= 3600, {
    days: r,
    hours: n,
    minutes: Math.floor(t / 60),
    seconds: t % 60
  };
}, Gr = (e) => {
  const t = e.dataset.esCfgId;
  if (!t) return Ee(void 0);
  const r = document.getElementById(t);
  if (!r?.textContent?.trim()) return Ee(void 0);
  try {
    return Ee(JSON.parse(r.textContent));
  } catch {
    return Ee(void 0);
  }
}, Ye = "America/Chicago", Yr = (e) => {
  e.data("estimatedShipping", (t = {}) => ({
    cutOffHour: 0,
    leadTime: 0,
    messageHtml: "",
    isCustomMessage: !1,
    restrictedDays: [],
    restrictedDates: [],
    message: "",
    intervalId: null,
    async init() {
      "Temporal" in globalThis || await import("./global.esm-NyKaXWp-.js"), Object.assign(this, Gr(this.$el), t), this.tick(), this.intervalId = setInterval(() => this.tick(), 1e3);
    },
    destroy() {
      clearInterval(this.intervalId);
    },
    tick() {
      const r = Temporal.Now.zonedDateTimeISO(Ye), n = this.nextCutoffDate(), i = n.epochNanoseconds - r.epochNanoseconds, { days: a, hours: o, minutes: s, seconds: c } = Kr(i <= 0n ? 0 : Number(i / 1000000000n)), l = [];
      (l.length || a) && l.push(a === 1 ? `${a} day` : `${a} days`), (l.length || o) && l.push(o === 1 ? `${o} hour` : `${o} hours`), (l.length || s) && l.push(s === 1 ? `${s} minute` : `${s} minutes`), (l.length || c) && l.push(c === 1 ? `${c} second` : `${c} seconds`);
      const h = this.nextShippingDate(n), u = h.toPlainDate().equals(Temporal.Now.plainDateISO()) ? "Today" : Wr[ut(h)];
      this.message = String(this.messageHtml).replace("%countdown%", l.join(", ")).replace("%ship_day%", u);
    },
    nextCutoffDate() {
      const r = Temporal.Now.zonedDateTimeISO(Ye);
      let n = Temporal.Now.zonedDateTimeISO(Ye).with({
        hour: this.cutOffHour,
        minute: 0,
        second: 0,
        millisecond: 0
      });
      for (Temporal.ZonedDateTime.compare(n, r) === -1 && (n = n.add({ days: 1 })); this.isDateRestricted(n); ) n = n.add({ days: 1 });
      return n;
    },
    nextShippingDate(r) {
      let n = r, i = this.leadTime;
      for (; this.isDateRestricted(n) || i > 0; )
        n = n.add({ days: 1 }), this.isDateRestricted(n) || i--;
      return n;
    },
    isDateRestricted(r) {
      if (this.restrictedDays.includes(ut(r))) return !0;
      const n = r.toPlainDate().toString(), i = n.slice(5);
      return this.restrictedDates.some((a) => a === n || a === i);
    }
  }));
}, Jr = (e) => {
  e.data("filterController", (n) => {
    const i = [];
    return n || console.error("No grid selector provided to filterController"), {
      forms: {},
      async init() {
        await e.nextTick(), this.facetChange(!1), i.push(e.effect(() => this.filterProducts())), window.addEventListener("popstate", this.updateFromHistory.bind(this));
      },
      updateFromHistory({ state: a }) {
        this.facetData = a ? JSON.parse(a) : this.facetChange();
        const o = this.facetData;
        document.querySelectorAll("#filter-drawer input[type=checkbox]").forEach((l) => {
          l.checked = o.some(([h, u]) => h === l.name && u === l.value);
        });
        const s = o.find(([l]) => l === "sort_by")?.[1];
        if (!s) return;
        const c = document.querySelector('select[name="sort_by"]');
        c && (c.value = s);
      },
      destroy() {
        i.forEach(e.release);
      },
      _expanded: [!0],
      expanded(a) {
        return this._expanded[a];
      },
      expand(a) {
        this._expanded[a] = !this._expanded[a];
      },
      open: !1,
      fadeTransition: wr,
      slideTransition: jt,
      facetData: [],
      facetChange(a = !0) {
        return this.facetData = Object.values(this.forms).flatMap((o) => Array.from(new FormData(o).entries())).filter(([o, s]) => !(o === "sort_by" && s === "manual" || o === "page" && (a || s === "1"))), this.facetData;
      },
      filterProducts() {
        r(this.facetData, n);
      },
      get isFiltered() {
        return this.facetData.some(([a]) => ![
          "type",
          "sort_by",
          "q"
        ].includes(a));
      }
    };
  });
  let t = !0;
  const r = yr(async (n, i) => {
    const a = new URL(window.location.href);
    a.search = new URLSearchParams(n).toString();
    const o = await Nr(a);
    if (!o) return;
    t || ke(o, i);
    const s = a.toString() === window.location.href;
    history[t || s ? "replaceState" : "pushState"](JSON.stringify(n), "", a.toString()), t = !1;
  });
}, Xr = (e) => {
  e.data("meganav", () => ({
    isVisible: !1,
    meganavIndex: 0,
    init() {
      this.meganavIndex = this.$store.meganavState.registerItem();
    },
    show() {
      this.isVisible = !0, this.$store.meganavState.items[this.meganavIndex] = !0;
    },
    hide() {
      this.isVisible = !1, this.$store.meganavState.items[this.meganavIndex] = !1;
    },
    toggle() {
      this.isVisible = !this.isVisible, e.nextTick(() => this.$store.meganavStateIsOpen = this.isVisible);
    },
    expand: {
      "@mouseover"() {
        this.show();
      },
      "@mouseleave"() {
        this.hide();
      },
      "@keydown.tab"() {
        this.$event.target.isSameNode(this.$focus.getLast()) && this.isVisible && !this.$event.shiftKey && (this.isVisible = !1);
      },
      "@keydown.shift.tab"() {
        this.$event.target.isSameNode(this.$focus.getFirst()) && this.isVisible && (this.isVisible = !1);
      },
      "@keydown.esc"() {
        this.$focus.getFirst().focus(), this.isVisible = !1;
      },
      "@keydown.down.prevent"() {
        this.$focus.wrap().next();
      },
      "@keydown.up.prevent"() {
        this.$focus.wrap().previous();
      }
    },
    fade: {
      "x-transition:enter": "transition-[top] duration-200",
      "x-transition:enter-start": "top-5",
      "x-transition:enter-end": "top-3",
      "x-transition:leave": "transition-[top] duration-200",
      "x-transition:leave-start": "top-3",
      "x-transition:leave-end": "top-5"
    }
  })), e.store("meganavState", {
    get isOpen() {
      return this.items.length ? this.items.some((t) => t) : !1;
    },
    items: [],
    registerItem() {
      return this.items.push(!1), this.items.length - 1;
    }
  });
}, Zr = (e) => e.data("mobileMenu", () => ({
  size: "auto",
  adjustSize() {
    const t = this.$refs.menuDrawer;
    if (!t) return;
    const r = t.closest("section > :is(div.relative, div.absolute)");
    if (!r) return;
    const n = r.getBoundingClientRect(), i = n.y + n.height;
    this.size = `${i}px`;
  },
  adjustToLargestPart(t) {
    const r = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT);
    let n = 0, i = t;
    do
      n = Math.max(n, i.scrollHeight);
    while (i = r.nextNode());
    this.size = `${n + 5}px`;
  },
  get isOpen() {
    return this.$nextTick(() => this.$dispatch("update-size")), this.$store.mobileMenu.visible;
  },
  open() {
    this.$store.mobileMenu.show();
  },
  close() {
    this.$store.mobileMenu.hide();
  },
  cleanUp() {
    this.$refs.menuDrawerList.querySelectorAll("details").forEach((t) => t.removeAttribute("open"));
  }
})), Qr = (e) => e.data("modal", () => ({
  isOpen: !1,
  init() {
    this.$watch("$store.modal.isOpen", (t) => {
      !t && this.close(!1);
    });
  },
  open() {
    this.$dispatch("nt:modal-open"), this.isOpen = !0, this.$store.modal.open();
  },
  close(t = !0) {
    this.$dispatch("nt:modal-close"), this.isOpen = !1, t && this.$store.modal.close();
  }
})), en = (e) => {
  e.data("productCard", (t) => ({
    variant: t,
    get image() {
      return this.variant.featuredImage;
    },
    get currentShade() {
      const { name: r, description: n, color: i } = this.variant;
      return {
        name: r,
        description: n,
        color: i
      };
    },
    get colorDisplay() {
      const { name: r } = this.variant;
      return `${r}`;
    },
    get queryString() {
      return `?variant=${this.variant.id}`;
    },
    setShade(r) {
      Object.assign(this, { variant: r });
    },
    get isOnSale() {
      return this.variant.price < (this.variant.compare_at_price ?? 0);
    },
    formatMoney: et
  }));
}, tn = (e) => {
  e.data("quickOrder", (t) => ({
    removing: !1,
    get cart() {
      return this.$store.cart;
    },
    get productEntries() {
      return this.cart.items.filter((r) => r.product_id === t);
    },
    get quantity() {
      return this.productEntries.reduce((r, n) => r + n.quantity, 0);
    },
    get subtotal() {
      return this.$formatMoney(this.productEntries.reduce((r, n) => r + n.final_line_price, 0) / 100);
    },
    async removeAll() {
      this.removing = !0;
      for (const { id: r } of this.productEntries)
        await this.cart.removeItem(r), this.$dispatch("removeall", { id: r });
      this.removing = !1;
    }
  })), e.data("quickOrderRow", (t, r) => ({
    quantity: e.store("cart").items.find((n) => n.id === Number(t))?.quantity ?? 0,
    price: r,
    get priceDisplay() {
      return this.$formatMoney(this.price * this.quantity / 100);
    }
  })), e.data("quickQuantity", (t) => ({
    q: 0,
    get quant() {
      return this.q;
    },
    set quant(r) {
      r = Math.max(0, r), this.q = r;
    }
  }));
}, rn = (e) => e.data("sizes", (t) => ({
  ...t,
  changeSize(r) {
    this.$dispatch("product-change", { product: r.product }), history.replaceState(null, r.product.title, r.url);
  }
})), nn = (e) => {
  e.data("stickyATC", () => ({
    show: !1,
    PDPATC: document.querySelector("#atc-button button[name=add]"),
    onScroll() {
      if (!this.PDPATC) return;
      const t = this.PDPATC.getBoundingClientRect();
      this.show = t.top < 25;
    }
  }));
}, an = (e) => e.directive("stickyheader", (t, r, { cleanup: n }) => {
  const i = t.closest("section");
  if (!i || !("Animation" in globalThis)) return;
  const a = new Animation(new KeyframeEffect(i, [{ top: "0px" }, { get top() {
    return `-${t.clientHeight}px`;
  } }], {
    duration: 500,
    fill: "both"
  }));
  a.persist(), a.reverse(), a.finish();
  const o = e.effect(() => {
    a.playbackRate = +(e.$scroll.direction === "down" && !e.$scroll.nearTop && !e.store("search").isOpen) * 2 - 1;
  });
  n(() => e.release(o));
}), on = [
  xr,
  Er,
  Yr,
  Sr,
  Br,
  Hr,
  qr,
  Jr,
  Xr,
  Zr,
  Qr,
  en,
  tn,
  rn,
  nn,
  an
], Ae = Math.min, te = Math.max, Fe = Math.round, Se = Math.floor, X = (e) => ({
  x: e,
  y: e
}), sn = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, cn = {
  start: "end",
  end: "start"
};
function dt(e, t, r) {
  return te(e, Ae(t, r));
}
function Be(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function re(e) {
  return e.split("-")[0];
}
function He(e) {
  return e.split("-")[1];
}
function Wt(e) {
  return e === "x" ? "y" : "x";
}
function Kt(e) {
  return e === "y" ? "height" : "width";
}
function qe(e) {
  return ["top", "bottom"].includes(re(e)) ? "y" : "x";
}
function Gt(e) {
  return Wt(qe(e));
}
function ln(e, t, r) {
  r === void 0 && (r = !1);
  const n = He(e), i = Gt(e), a = Kt(i);
  let o = i === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (o = Ie(o)), [o, Ie(o)];
}
function un(e) {
  const t = Ie(e);
  return [
    Je(e),
    t,
    Je(t)
  ];
}
function Je(e) {
  return e.replace(/start|end/g, (t) => cn[t]);
}
function dn(e, t, r) {
  const n = ["left", "right"], i = ["right", "left"], a = ["top", "bottom"], o = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? i : n : t ? n : i;
    case "left":
    case "right":
      return t ? a : o;
    default:
      return [];
  }
}
function fn(e, t, r, n) {
  const i = He(e);
  let a = dn(re(e), r === "start", n);
  return i && (a = a.map((o) => o + "-" + i), t && (a = a.concat(a.map(Je)))), a;
}
function Ie(e) {
  return e.replace(/left|right|bottom|top/g, (t) => sn[t]);
}
function hn(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function vn(e) {
  return typeof e != "number" ? hn(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Le(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function ft(e, t, r) {
  let { reference: n, floating: i } = e;
  const a = qe(t), o = Gt(t), s = Kt(o), c = re(t), l = a === "y", h = n.x + n.width / 2 - i.width / 2, u = n.y + n.height / 2 - i.height / 2, v = n[s] / 2 - i[s] / 2;
  let p;
  switch (c) {
    case "top":
      p = {
        x: h,
        y: n.y - i.height
      };
      break;
    case "bottom":
      p = {
        x: h,
        y: n.y + n.height
      };
      break;
    case "right":
      p = {
        x: n.x + n.width,
        y: u
      };
      break;
    case "left":
      p = {
        x: n.x - i.width,
        y: u
      };
      break;
    default:
      p = {
        x: n.x,
        y: n.y
      };
  }
  switch (He(t)) {
    case "start":
      p[o] -= v * (r && l ? -1 : 1);
      break;
    case "end":
      p[o] += v * (r && l ? -1 : 1);
      break;
  }
  return p;
}
var pn = async (e, t, r) => {
  const { placement: n = "bottom", strategy: i = "absolute", middleware: a = [], platform: o } = r, s = a.filter(Boolean), c = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let l = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), { x: h, y: u } = ft(l, n, c), v = n, p = {}, g = 0;
  for (let y = 0; y < s.length; y++) {
    const { name: m, fn: x } = s[y], { x: C, y: _, data: L, reset: I } = await x({
      x: h,
      y: u,
      initialPlacement: n,
      placement: v,
      strategy: i,
      middlewareData: p,
      rects: l,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (h = C ?? h, u = _ ?? u, p = {
      ...p,
      [m]: {
        ...p[m],
        ...L
      }
    }, I && g <= 50) {
      g++, typeof I == "object" && (I.placement && (v = I.placement), I.rects && (l = I.rects === !0 ? await o.getElementRects({
        reference: e,
        floating: t,
        strategy: i
      }) : I.rects), { x: h, y: u } = ft(l, v, c)), y = -1;
      continue;
    }
  }
  return {
    x: h,
    y: u,
    placement: v,
    strategy: i,
    middlewareData: p
  };
};
async function Yt(e, t) {
  var r;
  t === void 0 && (t = {});
  const { x: n, y: i, platform: a, rects: o, elements: s, strategy: c } = e, { boundary: l = "clippingAncestors", rootBoundary: h = "viewport", elementContext: u = "floating", altBoundary: v = !1, padding: p = 0 } = Be(t, e), g = vn(p), y = s[v ? u === "floating" ? "reference" : "floating" : u], m = Le(await a.getClippingRect({
    element: (r = await (a.isElement == null ? void 0 : a.isElement(y))) == null || r ? y : y.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: l,
    rootBoundary: h,
    strategy: c
  })), x = u === "floating" ? {
    ...o.floating,
    x: n,
    y: i
  } : o.reference, C = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), _ = await (a.isElement == null ? void 0 : a.isElement(C)) ? await (a.getScale == null ? void 0 : a.getScale(C)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, L = Le(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: x,
    offsetParent: C,
    strategy: c
  }) : x);
  return {
    top: (m.top - L.top + g.top) / _.y,
    bottom: (L.bottom - m.bottom + g.bottom) / _.y,
    left: (m.left - L.left + g.left) / _.x,
    right: (L.right - m.right + g.right) / _.x
  };
}
var mn = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, n;
      const { placement: i, middlewareData: a, rects: o, initialPlacement: s, platform: c, elements: l } = t, { mainAxis: h = !0, crossAxis: u = !0, fallbackPlacements: v, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: g = "none", flipAlignment: y = !0, ...m } = Be(e, t);
      if ((r = a.arrow) != null && r.alignmentOffset) return {};
      const x = re(i), C = re(s) === s, _ = await (c.isRTL == null ? void 0 : c.isRTL(l.floating)), L = v || (C || !y ? [Ie(s)] : un(s));
      !v && g !== "none" && L.push(...fn(s, y, g, _));
      const I = [s, ...L], D = await Yt(t, m), k = [];
      let F = ((n = a.flip) == null ? void 0 : n.overflows) || [];
      if (h && k.push(D[x]), u) {
        const S = ln(i, o, _);
        k.push(D[S[0]], D[S[1]]);
      }
      if (F = [...F, {
        placement: i,
        overflows: k
      }], !k.every((S) => S <= 0)) {
        var U, W;
        const S = (((U = a.flip) == null ? void 0 : U.index) || 0) + 1, d = I[S];
        if (d) return {
          data: {
            index: S,
            overflows: F
          },
          reset: { placement: d }
        };
        let f = (W = F.filter((b) => b.overflows[0] <= 0).sort((b, E) => b.overflows[1] - E.overflows[1])[0]) == null ? void 0 : W.placement;
        if (!f) switch (p) {
          case "bestFit": {
            var P;
            const b = (P = F.map((E) => [E.placement, E.overflows.filter((w) => w > 0).reduce((w, O) => w + O, 0)]).sort((E, w) => E[1] - w[1])[0]) == null ? void 0 : P[0];
            b && (f = b);
            break;
          }
          case "initialPlacement":
            f = s;
            break;
        }
        if (i !== f) return { reset: { placement: f } };
      }
      return {};
    }
  };
};
async function gn(e, t) {
  const { placement: r, platform: n, elements: i } = e, a = await (n.isRTL == null ? void 0 : n.isRTL(i.floating)), o = re(r), s = He(r), c = qe(r) === "y", l = ["left", "top"].includes(o) ? -1 : 1, h = a && c ? -1 : 1, u = Be(t, e);
  let { mainAxis: v, crossAxis: p, alignmentAxis: g } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...u
  };
  return s && typeof g == "number" && (p = s === "end" ? g * -1 : g), c ? {
    x: p * h,
    y: v * l
  } : {
    x: v * l,
    y: p * h
  };
}
var bn = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      const { x: r, y: n } = t, i = await gn(t, e);
      return {
        x: r + i.x,
        y: n + i.y,
        data: i
      };
    }
  };
}, yn = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const { x: r, y: n, placement: i } = t, { mainAxis: a = !0, crossAxis: o = !1, limiter: s = { fn: (m) => {
        let { x, y: C } = m;
        return {
          x,
          y: C
        };
      } }, ...c } = Be(e, t), l = {
        x: r,
        y: n
      }, h = await Yt(t, c), u = qe(re(i)), v = Wt(u);
      let p = l[v], g = l[u];
      if (a) {
        const m = v === "y" ? "top" : "left", x = v === "y" ? "bottom" : "right", C = p + h[m], _ = p - h[x];
        p = dt(C, p, _);
      }
      if (o) {
        const m = u === "y" ? "top" : "left", x = u === "y" ? "bottom" : "right", C = g + h[m], _ = g - h[x];
        g = dt(C, g, _);
      }
      const y = s.fn({
        ...t,
        [v]: p,
        [u]: g
      });
      return {
        ...y,
        data: {
          x: y.x - r,
          y: y.y - n
        }
      };
    }
  };
};
function Z(e) {
  return Jt(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function q(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Y(e) {
  var t;
  return (t = (Jt(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Jt(e) {
  return e instanceof Node || e instanceof q(e).Node;
}
function G(e) {
  return e instanceof Element || e instanceof q(e).Element;
}
function z(e) {
  return e instanceof HTMLElement || e instanceof q(e).HTMLElement;
}
function ht(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof q(e).ShadowRoot;
}
function we(e) {
  const { overflow: t, overflowX: r, overflowY: n, display: i } = V(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && !["inline", "contents"].includes(i);
}
function wn(e) {
  return [
    "table",
    "td",
    "th"
  ].includes(Z(e));
}
function tt(e) {
  const t = rt(), r = V(e);
  return r.transform !== "none" || r.perspective !== "none" || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || [
    "transform",
    "perspective",
    "filter"
  ].some((n) => (r.willChange || "").includes(n)) || [
    "paint",
    "layout",
    "strict",
    "content"
  ].some((n) => (r.contain || "").includes(n));
}
function xn(e) {
  let t = ce(e);
  for (; z(t) && !Ve(t); ) {
    if (tt(t)) return t;
    t = ce(t);
  }
  return null;
}
function rt() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Ve(e) {
  return [
    "html",
    "body",
    "#document"
  ].includes(Z(e));
}
function V(e) {
  return q(e).getComputedStyle(e);
}
function Ue(e) {
  return G(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function ce(e) {
  if (Z(e) === "html") return e;
  const t = e.assignedSlot || e.parentNode || ht(e) && e.host || Y(e);
  return ht(t) ? t.host : t;
}
function Xt(e) {
  const t = ce(e);
  return Ve(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : z(t) && we(t) ? t : Xt(t);
}
function ve(e, t, r) {
  var n;
  t === void 0 && (t = []), r === void 0 && (r = !0);
  const i = Xt(e), a = i === ((n = e.ownerDocument) == null ? void 0 : n.body), o = q(i);
  return a ? t.concat(o, o.visualViewport || [], we(i) ? i : [], o.frameElement && r ? ve(o.frameElement) : []) : t.concat(i, ve(i, [], r));
}
function Zt(e) {
  const t = V(e);
  let r = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const i = z(e), a = i ? e.offsetWidth : r, o = i ? e.offsetHeight : n, s = Fe(r) !== a || Fe(n) !== o;
  return s && (r = a, n = o), {
    width: r,
    height: n,
    $: s
  };
}
function nt(e) {
  return G(e) ? e : e.contextElement;
}
function se(e) {
  const t = nt(e);
  if (!z(t)) return X(1);
  const r = t.getBoundingClientRect(), { width: n, height: i, $: a } = Zt(t);
  let o = (a ? Fe(r.width) : r.width) / n, s = (a ? Fe(r.height) : r.height) / i;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
var En = /* @__PURE__ */ X(0);
function Qt(e) {
  const t = q(e);
  return !rt() || !t.visualViewport ? En : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Sn(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== q(e) ? !1 : t;
}
function ne(e, t, r, n) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const i = e.getBoundingClientRect(), a = nt(e);
  let o = X(1);
  t && (n ? G(n) && (o = se(n)) : o = se(e));
  const s = Sn(a, r, n) ? Qt(a) : X(0);
  let c = (i.left + s.x) / o.x, l = (i.top + s.y) / o.y, h = i.width / o.x, u = i.height / o.y;
  if (a) {
    const v = q(a), p = n && G(n) ? q(n) : n;
    let g = v.frameElement;
    for (; g && n && p !== v; ) {
      const y = se(g), m = g.getBoundingClientRect(), x = V(g), C = m.left + (g.clientLeft + parseFloat(x.paddingLeft)) * y.x, _ = m.top + (g.clientTop + parseFloat(x.paddingTop)) * y.y;
      c *= y.x, l *= y.y, h *= y.x, u *= y.y, c += C, l += _, g = q(g).frameElement;
    }
  }
  return Le({
    width: h,
    height: u,
    x: c,
    y: l
  });
}
function Tn(e) {
  let { rect: t, offsetParent: r, strategy: n } = e;
  const i = z(r), a = Y(r);
  if (r === a) return t;
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = X(1);
  const c = X(0);
  if ((i || !i && n !== "fixed") && ((Z(r) !== "body" || we(a)) && (o = Ue(r)), z(r))) {
    const l = ne(r);
    s = se(r), c.x = l.x + r.clientLeft, c.y = l.y + r.clientTop;
  }
  return {
    width: t.width * s.x,
    height: t.height * s.y,
    x: t.x * s.x - o.scrollLeft * s.x + c.x,
    y: t.y * s.y - o.scrollTop * s.y + c.y
  };
}
function kn(e) {
  return Array.from(e.getClientRects());
}
function er(e) {
  return ne(Y(e)).left + Ue(e).scrollLeft;
}
function Nn(e) {
  const t = Y(e), r = Ue(e), n = e.ownerDocument.body, i = te(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), a = te(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let o = -r.scrollLeft + er(e);
  const s = -r.scrollTop;
  return V(n).direction === "rtl" && (o += te(t.clientWidth, n.clientWidth) - i), {
    width: i,
    height: a,
    x: o,
    y: s
  };
}
function On(e, t) {
  const r = q(e), n = Y(e), i = r.visualViewport;
  let a = n.clientWidth, o = n.clientHeight, s = 0, c = 0;
  if (i) {
    a = i.width, o = i.height;
    const l = rt();
    (!l || l && t === "fixed") && (s = i.offsetLeft, c = i.offsetTop);
  }
  return {
    width: a,
    height: o,
    x: s,
    y: c
  };
}
function Cn(e, t) {
  const r = ne(e, !0, t === "fixed"), n = r.top + e.clientTop, i = r.left + e.clientLeft, a = z(e) ? se(e) : X(1);
  return {
    width: e.clientWidth * a.x,
    height: e.clientHeight * a.y,
    x: i * a.x,
    y: n * a.y
  };
}
function vt(e, t, r) {
  let n;
  if (t === "viewport") n = On(e, r);
  else if (t === "document") n = Nn(Y(e));
  else if (G(t)) n = Cn(t, r);
  else {
    const i = Qt(e);
    n = {
      ...t,
      x: t.x - i.x,
      y: t.y - i.y
    };
  }
  return Le(n);
}
function tr(e, t) {
  const r = ce(e);
  return r === t || !G(r) || Ve(r) ? !1 : V(r).position === "fixed" || tr(r, t);
}
function _n(e, t) {
  const r = t.get(e);
  if (r) return r;
  let n = ve(e, [], !1).filter((s) => G(s) && Z(s) !== "body"), i = null;
  const a = V(e).position === "fixed";
  let o = a ? ce(e) : e;
  for (; G(o) && !Ve(o); ) {
    const s = V(o), c = tt(o);
    !c && s.position === "fixed" && (i = null), (a ? !c && !i : !c && s.position === "static" && i && ["absolute", "fixed"].includes(i.position) || we(o) && !c && tr(e, o)) ? n = n.filter((l) => l !== o) : i = s, o = ce(o);
  }
  return t.set(e, n), n;
}
function An(e) {
  let { element: t, boundary: r, rootBoundary: n, strategy: i } = e;
  const a = [...r === "clippingAncestors" ? _n(t, this._c) : [].concat(r), n], o = a[0], s = a.reduce((c, l) => {
    const h = vt(t, l, i);
    return c.top = te(h.top, c.top), c.right = Ae(h.right, c.right), c.bottom = Ae(h.bottom, c.bottom), c.left = te(h.left, c.left), c;
  }, vt(t, o, i));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function Fn(e) {
  return Zt(e);
}
function In(e, t, r) {
  const n = z(t), i = Y(t), a = r === "fixed", o = ne(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = X(0);
  if (n || !n && !a)
    if ((Z(t) !== "body" || we(i)) && (s = Ue(t)), n) {
      const l = ne(t, !0, a, t);
      c.x = l.x + t.clientLeft, c.y = l.y + t.clientTop;
    } else i && (c.x = er(i));
  return {
    x: o.left + s.scrollLeft - c.x,
    y: o.top + s.scrollTop - c.y,
    width: o.width,
    height: o.height
  };
}
function pt(e, t) {
  return !z(e) || V(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function rr(e, t) {
  const r = q(e);
  if (!z(e)) return r;
  let n = pt(e, t);
  for (; n && wn(n) && V(n).position === "static"; ) n = pt(n, t);
  return n && (Z(n) === "html" || Z(n) === "body" && V(n).position === "static" && !tt(n)) ? r : n || xn(e) || r;
}
var Ln = async function(e) {
  let { reference: t, floating: r, strategy: n } = e;
  const i = this.getOffsetParent || rr, a = this.getDimensions;
  return {
    reference: In(t, await i(r), n),
    floating: {
      x: 0,
      y: 0,
      ...await a(r)
    }
  };
};
function Rn(e) {
  return V(e).direction === "rtl";
}
var Dn = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Tn,
  getDocumentElement: Y,
  getClippingRect: An,
  getOffsetParent: rr,
  getElementRects: Ln,
  getClientRects: kn,
  getDimensions: Fn,
  getScale: se,
  isElement: G,
  isRTL: Rn
};
function $n(e, t) {
  let r = null, n;
  const i = Y(e);
  function a() {
    clearTimeout(n), r && r.disconnect(), r = null;
  }
  function o(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), a();
    const { left: l, top: h, width: u, height: v } = e.getBoundingClientRect();
    if (s || t(), !u || !v) return;
    const p = Se(h), g = Se(i.clientWidth - (l + u)), y = Se(i.clientHeight - (h + v)), m = Se(l), x = {
      rootMargin: -p + "px " + -g + "px " + -y + "px " + -m + "px",
      threshold: te(0, Ae(1, c)) || 1
    };
    let C = !0;
    function _(L) {
      const I = L[0].intersectionRatio;
      if (I !== c) {
        if (!C) return o();
        I ? o(!1, I) : n = setTimeout(() => {
          o(!1, 1e-7);
        }, 100);
      }
      C = !1;
    }
    try {
      r = new IntersectionObserver(_, {
        ...x,
        root: i.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(_, x);
    }
    r.observe(e);
  }
  return o(!0), a;
}
function Pn(e, t, r, n) {
  n === void 0 && (n = {});
  const { ancestorScroll: i = !0, ancestorResize: a = !0, elementResize: o = typeof ResizeObserver == "function", layoutShift: s = typeof IntersectionObserver == "function", animationFrame: c = !1 } = n, l = nt(e), h = i || a ? [...l ? ve(l) : [], ...ve(t)] : [];
  h.forEach((x) => {
    i && x.addEventListener("scroll", r, { passive: !0 }), a && x.addEventListener("resize", r);
  });
  const u = l && s ? $n(l, r) : null;
  let v = -1, p = null;
  o && (p = new ResizeObserver((x) => {
    let [C] = x;
    C && C.target === l && p && (p.unobserve(t), cancelAnimationFrame(v), v = requestAnimationFrame(() => {
      p && p.observe(t);
    })), r();
  }), l && !c && p.observe(l), p.observe(t));
  let g, y = c ? ne(e) : null;
  c && m();
  function m() {
    const x = ne(e);
    y && (x.x !== y.x || x.y !== y.y || x.width !== y.width || x.height !== y.height) && r(), y = x, g = requestAnimationFrame(m);
  }
  return r(), () => {
    h.forEach((x) => {
      i && x.removeEventListener("scroll", r), a && x.removeEventListener("resize", r);
    }), u && u(), p && p.disconnect(), p = null, c && cancelAnimationFrame(g);
  };
}
var Mn = (e, t, r) => {
  const n = /* @__PURE__ */ new Map(), i = {
    platform: Dn,
    ...r
  }, a = {
    ...i.platform,
    _c: n
  };
  return pn(e, t, {
    ...i,
    platform: a
  });
};
function jn(e) {
  e.magic("anchor", (t) => {
    if (!t._x_anchor) throw "Alpine: No x-anchor directive found on element using $anchor...";
    return t._x_anchor;
  }), e.interceptClone((t, r) => {
    t && t._x_anchor && !r._x_anchor && (r._x_anchor = t._x_anchor);
  }), e.directive("anchor", e.skipDuringClone((t, { expression: r, modifiers: n, value: i }, { evaluate: a, effect: o, cleanup: s }) => {
    let { placement: c, offsetValue: l, unstyled: h, strategy: u, allowFlip: v } = gt(n);
    t._x_anchor = e.reactive({
      x: 0,
      y: 0
    });
    let p = null, g = null;
    o(() => {
      let y = a(r);
      if (y && p !== y) {
        g && g(), p = y;
        let m = () => {
          let x;
          Mn(y, t, {
            placement: c,
            strategy: u,
            middleware: [
              v && mn(),
              yn({ padding: 5 }),
              bn(l)
            ]
          }).then(({ x: C, y: _ }) => {
            h || mt(t, C, _, u), JSON.stringify({
              x: C,
              y: _
            }) !== x && (t._x_anchor.x = C, t._x_anchor.y = _), x = JSON.stringify({
              x: C,
              y: _
            });
          });
        };
        g = Pn(y, t, () => m());
      }
    }), s(() => {
      g && g();
    });
  }, (t, { expression: r, modifiers: n, value: i }, { cleanup: a, evaluate: o }) => {
    let { placement: s, offsetValue: c, unstyled: l, strategy: h } = gt(n);
    t._x_anchor && (l || mt(t, t._x_anchor.x, t._x_anchor.y, h));
  }));
}
function mt(e, t, r, n = "absolute") {
  Object.assign(e.style, {
    left: t + "px",
    top: r + "px",
    position: n
  });
}
function gt(e) {
  let t = [
    "top",
    "top-start",
    "top-end",
    "right",
    "right-start",
    "right-end",
    "bottom",
    "bottom-start",
    "bottom-end",
    "left",
    "left-start",
    "left-end"
  ].find((o) => e.includes(o)), r = 0;
  if (e.includes("offset")) {
    let o = e.findIndex((s) => s === "offset");
    r = e[o + 1] !== void 0 ? Number(e[o + 1]) : r;
  }
  let n = e.includes("no-style"), i = !e.includes("noflip"), a = e.includes("fixed") ? "fixed" : "absolute";
  return {
    placement: t,
    offsetValue: r,
    unstyled: n,
    strategy: a,
    allowFlip: i
  };
}
var Bn = jn;
function Hn(e) {
  e.directive("collapse", t), t.inline = (r, { modifiers: n }) => {
    n.includes("min") && (r._x_doShow = () => {
    }, r._x_doHide = () => {
    });
  };
  function t(r, { modifiers: n }) {
    let i = bt(n, "duration", 250) / 1e3, a = bt(n, "min", 0), o = !n.includes("min");
    r._x_isShown || (r.style.height = `${a}px`), !r._x_isShown && o && (r.hidden = !0), r._x_isShown || (r.style.overflow = "hidden");
    let s = (l, h) => {
      let u = e.setStyles(l, h);
      return h.height ? () => {
      } : u;
    }, c = {
      transitionProperty: "height",
      transitionDuration: `${i}s`,
      transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)"
    };
    r._x_transition = {
      in(l = () => {
      }, h = () => {
      }) {
        o && (r.hidden = !1), o && (r.style.display = null);
        let u = r.getBoundingClientRect().height;
        r.style.height = "auto";
        let v = r.getBoundingClientRect().height;
        u === v && (u = a), e.transition(r, e.setStyles, {
          during: c,
          start: { height: u + "px" },
          end: { height: v + "px" }
        }, () => r._x_isShown = !0, () => {
          Math.abs(r.getBoundingClientRect().height - v) < 1 && (r.style.overflow = null);
        });
      },
      out(l = () => {
      }, h = () => {
      }) {
        let u = r.getBoundingClientRect().height;
        e.transition(r, s, {
          during: c,
          start: { height: u + "px" },
          end: { height: a + "px" }
        }, () => r.style.overflow = "hidden", () => {
          r._x_isShown = !1, r.style.height == `${a}px` && o && (r.style.display = "none", r.hidden = !0);
        });
      }
    };
  }
}
function bt(e, t, r) {
  if (e.indexOf(t) === -1) return r;
  const n = e[e.indexOf(t) + 1];
  if (!n) return r;
  if (t === "duration") {
    let i = n.match(/([0-9]+)ms/);
    if (i) return i[1];
  }
  if (t === "min") {
    let i = n.match(/([0-9]+)px/);
    if (i) return i[1];
  }
  return n;
}
var qn = Hn, nr = [
  "input:not([inert]):not([inert] *)",
  "select:not([inert]):not([inert] *)",
  "textarea:not([inert]):not([inert] *)",
  "a[href]:not([inert]):not([inert] *)",
  "button:not([inert]):not([inert] *)",
  "[tabindex]:not(slot):not([inert]):not([inert] *)",
  "audio[controls]:not([inert]):not([inert] *)",
  "video[controls]:not([inert]):not([inert] *)",
  '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)',
  "details>summary:first-of-type:not([inert]):not([inert] *)",
  "details:not([inert]):not([inert] *)"
], Re = /* @__PURE__ */ nr.join(","), ir = typeof Element > "u", ie = ir ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, De = !ir && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e?.ownerDocument;
}, $e = function(t, r) {
  var n;
  r === void 0 && (r = !0);
  var i = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "inert");
  return i === "" || i === "true" || r && t && (typeof t.closest == "function" ? t.closest("[inert]") : $e(t.parentNode));
}, Vn = function(t) {
  var r, n = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "contenteditable");
  return n === "" || n === "true";
}, ar = function(t, r, n) {
  if ($e(t)) return [];
  var i = Array.prototype.slice.apply(t.querySelectorAll(Re));
  return r && ie.call(t, Re) && i.unshift(t), i = i.filter(n), i;
}, Pe = function(t, r, n) {
  for (var i = [], a = Array.from(t); a.length; ) {
    var o = a.shift();
    if (!$e(o, !1))
      if (o.tagName === "SLOT") {
        var s = o.assignedElements(), c = Pe(s.length ? s : o.children, !0, n);
        n.flatten ? i.push.apply(i, c) : i.push({
          scopeParent: o,
          candidates: c
        });
      } else {
        ie.call(o, Re) && n.filter(o) && (r || !t.includes(o)) && i.push(o);
        var l = o.shadowRoot || typeof n.getShadowRoot == "function" && n.getShadowRoot(o), h = !$e(l, !1) && (!n.shadowRootFilter || n.shadowRootFilter(o));
        if (l && h) {
          var u = Pe(l === !0 ? o.children : l.children, !0, n);
          n.flatten ? i.push.apply(i, u) : i.push({
            scopeParent: o,
            candidates: u
          });
        } else a.unshift.apply(a, o.children);
      }
  }
  return i;
}, or = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, ee = function(t) {
  if (!t) throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || Vn(t)) && !or(t) ? 0 : t.tabIndex;
}, Un = function(t, r) {
  var n = ee(t);
  return n < 0 && r && !or(t) ? 0 : n;
}, zn = function(t, r) {
  return t.tabIndex === r.tabIndex ? t.documentOrder - r.documentOrder : t.tabIndex - r.tabIndex;
}, sr = function(t) {
  return t.tagName === "INPUT";
}, Wn = function(t) {
  return sr(t) && t.type === "hidden";
}, Kn = function(t) {
  return t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
}, Gn = function(t, r) {
  for (var n = 0; n < t.length; n++) if (t[n].checked && t[n].form === r) return t[n];
}, Yn = function(t) {
  if (!t.name) return !0;
  var r = t.form || De(t), n = function(s) {
    return r.querySelectorAll('input[type="radio"][name="' + s + '"]');
  }, i;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function") i = n(window.CSS.escape(t.name));
  else try {
    i = n(t.name);
  } catch (o) {
    return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", o.message), !1;
  }
  var a = Gn(i, t.form);
  return !a || a === t;
}, Jn = function(t) {
  return sr(t) && t.type === "radio";
}, Xn = function(t) {
  return Jn(t) && !Yn(t);
}, Zn = function(t) {
  var r, n = t && De(t), i = (r = n) === null || r === void 0 ? void 0 : r.host, a = !1;
  if (n && n !== t) {
    var o, s, c;
    for (a = !!((o = i) !== null && o !== void 0 && (s = o.ownerDocument) !== null && s !== void 0 && s.contains(i) || t != null && (c = t.ownerDocument) !== null && c !== void 0 && c.contains(t)); !a && i; ) {
      var l, h, u;
      n = De(i), i = (l = n) === null || l === void 0 ? void 0 : l.host, a = !!((h = i) !== null && h !== void 0 && (u = h.ownerDocument) !== null && u !== void 0 && u.contains(i));
    }
  }
  return a;
}, yt = function(t) {
  var r = t.getBoundingClientRect(), n = r.width, i = r.height;
  return n === 0 && i === 0;
}, Qn = function(t, r) {
  var n = r.displayCheck, i = r.getShadowRoot;
  if (n === "full-native" && "checkVisibility" in t)
    return !t.checkVisibility({
      checkOpacity: !1,
      opacityProperty: !1,
      contentVisibilityAuto: !0,
      visibilityProperty: !0,
      checkVisibilityCSS: !0
    });
  if (getComputedStyle(t).visibility === "hidden") return !0;
  var a = ie.call(t, "details>summary:first-of-type") ? t.parentElement : t;
  if (ie.call(a, "details:not([open]) *")) return !0;
  if (!n || n === "full" || n === "full-native" || n === "legacy-full") {
    if (typeof i == "function") {
      for (var o = t; t; ) {
        var s = t.parentElement, c = De(t);
        if (s && !s.shadowRoot && i(s) === !0) return yt(t);
        t.assignedSlot ? t = t.assignedSlot : !s && c !== t.ownerDocument ? t = c.host : t = s;
      }
      t = o;
    }
    if (Zn(t)) return !t.getClientRects().length;
    if (n !== "legacy-full") return !0;
  } else if (n === "non-zero-area") return yt(t);
  return !1;
}, ei = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var r = t.parentElement; r; ) {
      if (r.tagName === "FIELDSET" && r.disabled) {
        for (var n = 0; n < r.children.length; n++) {
          var i = r.children.item(n);
          if (i.tagName === "LEGEND") return ie.call(r, "fieldset[disabled] *") ? !0 : !i.contains(t);
        }
        return !0;
      }
      r = r.parentElement;
    }
  return !1;
}, Me = function(t, r) {
  return !(r.disabled || Wn(r) || Qn(r, t) || Kn(r) || ei(r));
}, Xe = function(t, r) {
  return !(Xn(r) || ee(r) < 0 || !Me(t, r));
}, ti = function(t) {
  var r = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(r) || r >= 0);
}, cr = function(t) {
  var r = [], n = [];
  return t.forEach(function(i, a) {
    var o = !!i.scopeParent, s = o ? i.scopeParent : i, c = Un(s, o), l = o ? cr(i.candidates) : s;
    c === 0 ? o ? r.push.apply(r, l) : r.push(s) : n.push({
      documentOrder: a,
      tabIndex: c,
      item: i,
      isScope: o,
      content: l
    });
  }), n.sort(zn).reduce(function(i, a) {
    return a.isScope ? i.push.apply(i, a.content) : i.push(a.content), i;
  }, []).concat(r);
}, ri = function(t, r) {
  r = r || {};
  var n;
  return r.getShadowRoot ? n = Pe([t], r.includeContainer, {
    filter: Xe.bind(null, r),
    flatten: !1,
    getShadowRoot: r.getShadowRoot,
    shadowRootFilter: ti
  }) : n = ar(t, r.includeContainer, Xe.bind(null, r)), cr(n);
}, lr = function(t, r) {
  r = r || {};
  var n;
  return r.getShadowRoot ? n = Pe([t], r.includeContainer, {
    filter: Me.bind(null, r),
    flatten: !0,
    getShadowRoot: r.getShadowRoot
  }) : n = ar(t, r.includeContainer, Me.bind(null, r)), n;
}, ae = function(t, r) {
  if (r = r || {}, !t) throw new Error("No node provided");
  return ie.call(t, Re) === !1 ? !1 : Xe(r, t);
}, ni = /* @__PURE__ */ nr.concat("iframe:not([inert]):not([inert] *)").join(","), Ne = function(t, r) {
  if (r = r || {}, !t) throw new Error("No node provided");
  return ie.call(t, ni) === !1 ? !1 : Me(r, t);
};
function Ze(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function ii(e) {
  if (Array.isArray(e)) return Ze(e);
}
function wt(e, t, r, n, i, a, o) {
  try {
    var s = e[a](o), c = s.value;
  } catch (l) {
    r(l);
    return;
  }
  s.done ? t(c) : Promise.resolve(c).then(n, i);
}
function xt(e) {
  return function() {
    var t = this, r = arguments;
    return new Promise(function(n, i) {
      var a = e.apply(t, r);
      function o(c) {
        wt(a, n, i, o, s, "next", c);
      }
      function s(c) {
        wt(a, n, i, o, s, "throw", c);
      }
      o(void 0);
    });
  };
}
function Et(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = ur(e)) || t) {
      r && (e = r);
      var n = 0, i = function() {
      };
      return {
        s: i,
        n: function() {
          return n >= e.length ? { done: !0 } : {
            done: !1,
            value: e[n++]
          };
        },
        e: function(c) {
          throw c;
        },
        f: i
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a, o = !0, s = !1;
  return {
    s: function() {
      r = r.call(e);
    },
    n: function() {
      var c = r.next();
      return o = c.done, c;
    },
    e: function(c) {
      s = !0, a = c;
    },
    f: function() {
      try {
        o || r.return == null || r.return();
      } finally {
        if (s) throw a;
      }
    }
  };
}
function ai(e, t, r) {
  return (t = ui(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function oi(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function si() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function St(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Tt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? St(Object(r), !0).forEach(function(n) {
      ai(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : St(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function fe() {
  var e, t, r = typeof Symbol == "function" ? Symbol : {}, n = r.iterator || "@@iterator", i = r.toStringTag || "@@toStringTag";
  function a(p, g, y, m) {
    var x = g && g.prototype instanceof s ? g : s, C = Object.create(x.prototype);
    return H(C, "_invoke", (function(_, L, I) {
      var D, k, F, U = 0, W = I || [], P = !1, S = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function(f, b) {
          return D = f, k = 0, F = e, S.n = b, o;
        }
      };
      function d(f, b) {
        for (k = f, F = b, t = 0; !P && U && !E && t < W.length; t++) {
          var E, w = W[t], O = S.p, T = w[2];
          f > 3 ? (E = T === b) && (F = w[(k = w[4]) ? 5 : (k = 3, 3)], w[4] = w[5] = e) : w[0] <= O && ((E = f < 2 && O < w[1]) ? (k = 0, S.v = b, S.n = w[1]) : O < T && (E = f < 3 || w[0] > b || b > T) && (w[4] = f, w[5] = b, S.n = T, k = 0));
        }
        if (E || f > 1) return o;
        throw P = !0, b;
      }
      return function(f, b, E) {
        if (U > 1) throw TypeError("Generator is already running");
        for (P && b === 1 && d(b, E), k = b, F = E; (t = k < 2 ? e : F) || !P; ) {
          D || (k ? k < 3 ? (k > 1 && (S.n = -1), d(k, F)) : S.n = F : S.v = F);
          try {
            if (U = 2, D) {
              if (k || (f = "next"), t = D[f]) {
                if (!(t = t.call(D, F))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                F = t.value, k < 2 && (k = 0);
              } else k === 1 && (t = D.return) && t.call(D), k < 2 && (F = TypeError("The iterator does not provide a '" + f + "' method"), k = 1);
              D = e;
            } else if ((t = (P = S.n < 0) ? F : _.call(L, S)) !== o) break;
          } catch (w) {
            D = e, k = 1, F = w;
          } finally {
            U = 1;
          }
        }
        return {
          value: t,
          done: P
        };
      };
    })(p, y, m), !0), C;
  }
  var o = {};
  function s() {
  }
  function c() {
  }
  function l() {
  }
  t = Object.getPrototypeOf;
  var h = [][n] ? t(t([][n]())) : (H(t = {}, n, function() {
    return this;
  }), t), u = l.prototype = s.prototype = Object.create(h);
  function v(p) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(p, l) : (p.__proto__ = l, H(p, i, "GeneratorFunction")), p.prototype = Object.create(u), p;
  }
  return c.prototype = l, H(u, "constructor", l), H(l, "constructor", c), c.displayName = "GeneratorFunction", H(l, i, "GeneratorFunction"), H(u), H(u, i, "Generator"), H(u, n, function() {
    return this;
  }), H(u, "toString", function() {
    return "[object Generator]";
  }), (fe = function() {
    return {
      w: a,
      m: v
    };
  })();
}
function H(e, t, r, n) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch {
    i = 0;
  }
  H = function(a, o, s, c) {
    function l(h, u) {
      H(a, h, function(v) {
        return this._invoke(h, u, v);
      });
    }
    o ? i ? i(a, o, {
      value: s,
      enumerable: !c,
      configurable: !c,
      writable: !c
    }) : a[o] = s : (l("next", 0), l("throw", 1), l("return", 2));
  }, H(e, t, r, n);
}
function ci(e) {
  return ii(e) || oi(e) || ur(e) || si();
}
function li(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ui(e) {
  var t = li(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function ur(e, t) {
  if (e) {
    if (typeof e == "string") return Ze(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Ze(e, t) : void 0;
  }
}
var K = {
  getActiveTrap: function(t) {
    return t?.length > 0 ? t[t.length - 1] : null;
  },
  activateTrap: function(t, r) {
    r !== K.getActiveTrap(t) && K.pauseTrap(t);
    var n = t.indexOf(r);
    n === -1 || t.splice(n, 1), t.push(r);
  },
  deactivateTrap: function(t, r) {
    var n = t.indexOf(r);
    n !== -1 && t.splice(n, 1), K.unpauseTrap(t);
  },
  pauseTrap: function(t) {
    var r = K.getActiveTrap(t);
    r?._setPausedState(!0);
  },
  unpauseTrap: function(t) {
    var r = K.getActiveTrap(t);
    r && !r._isManuallyPaused() && r._setPausedState(!1);
  }
}, di = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, fi = function(t) {
  return t?.key === "Escape" || t?.key === "Esc" || t?.keyCode === 27;
}, he = function(t) {
  return t?.key === "Tab" || t?.keyCode === 9;
}, hi = function(t) {
  return he(t) && !t.shiftKey;
}, vi = function(t) {
  return he(t) && t.shiftKey;
}, kt = function(t) {
  return setTimeout(t, 0);
}, le = function(t) {
  for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++) n[i - 1] = arguments[i];
  return typeof t == "function" ? t.apply(void 0, n) : t;
}, Te = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, pi = [], mi = function(t, r) {
  var n = r?.document || document, i = r?.trapStack || pi, a = Tt({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isolateSubtrees: !1,
    isKeyForward: hi,
    isKeyBackward: vi
  }, r), o = {
    containers: [],
    containerGroups: [],
    tabbableGroups: [],
    adjacentElements: /* @__PURE__ */ new Set(),
    alreadySilent: /* @__PURE__ */ new Set(),
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    delayInitialFocusTimer: void 0,
    recentNavEvent: void 0
  }, s, c = function(d, f, b) {
    return d && d[f] !== void 0 ? d[f] : a[b || f];
  }, l = function(d, f) {
    var b = typeof f?.composedPath == "function" ? f.composedPath() : void 0;
    return o.containerGroups.findIndex(function(E) {
      var w = E.container, O = E.tabbableNodes;
      return w.contains(d) || b?.includes(w) || O.find(function(T) {
        return T === d;
      });
    });
  }, h = function(d) {
    var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, b = f.hasFallback, E = b === void 0 ? !1 : b, w = f.params, O = w === void 0 ? [] : w, T = a[d];
    if (typeof T == "function" && (T = T.apply(void 0, ci(O))), T === !0 && (T = void 0), !T) {
      if (T === void 0 || T === !1) return T;
      throw new Error("`".concat(d, "` was specified but was not a node, or did not return a node"));
    }
    var N = T;
    if (typeof T == "string") {
      try {
        N = n.querySelector(T);
      } catch (A) {
        throw new Error("`".concat(d, '` appears to be an invalid selector; error="').concat(A.message, '"'));
      }
      if (!N && !E)
        throw new Error("`".concat(d, "` as selector refers to no known node"));
    }
    return N;
  }, u = function() {
    var d = h("initialFocus", { hasFallback: !0 });
    if (d === !1) return !1;
    if (d === void 0 || d && !Ne(d, a.tabbableOptions)) if (l(n.activeElement) >= 0) d = n.activeElement;
    else {
      var f = o.tabbableGroups[0];
      d = f && f.firstTabbableNode || h("fallbackFocus");
    }
    else d === null && (d = h("fallbackFocus"));
    if (!d) throw new Error("Your focus-trap needs to have at least one focusable element");
    return d;
  }, v = function() {
    if (o.containerGroups = o.containers.map(function(d) {
      var f = ri(d, a.tabbableOptions), b = lr(d, a.tabbableOptions), E = f.length > 0 ? f[0] : void 0, w = f.length > 0 ? f[f.length - 1] : void 0, O = b.find(function(N) {
        return ae(N);
      }), T = b.slice().reverse().find(function(N) {
        return ae(N);
      });
      return {
        container: d,
        tabbableNodes: f,
        focusableNodes: b,
        posTabIndexesFound: !!f.find(function(N) {
          return ee(N) > 0;
        }),
        firstTabbableNode: E,
        lastTabbableNode: w,
        firstDomTabbableNode: O,
        lastDomTabbableNode: T,
        nextTabbableNode: function(A) {
          var M = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, B = f.indexOf(A);
          return B < 0 ? M ? b.slice(b.indexOf(A) + 1).find(function($) {
            return ae($);
          }) : b.slice(0, b.indexOf(A)).reverse().find(function($) {
            return ae($);
          }) : f[B + (M ? 1 : -1)];
        }
      };
    }), o.tabbableGroups = o.containerGroups.filter(function(d) {
      return d.tabbableNodes.length > 0;
    }), o.tabbableGroups.length <= 0 && !h("fallbackFocus")) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (o.containerGroups.find(function(d) {
      return d.posTabIndexesFound;
    }) && o.containerGroups.length > 1) throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, p = function(d) {
    var f = d.activeElement;
    if (f)
      return f.shadowRoot && f.shadowRoot.activeElement !== null ? p(f.shadowRoot) : f;
  }, g = function(d) {
    if (d !== !1 && d !== p(document)) {
      if (!d || !d.focus) {
        g(u());
        return;
      }
      d.focus({ preventScroll: !!a.preventScroll }), o.mostRecentlyFocusedNode = d, di(d) && d.select();
    }
  }, y = function(d) {
    var f = h("setReturnFocus", { params: [d] });
    return f || (f === !1 ? !1 : d);
  }, m = function(d) {
    var f = d.target, b = d.event, E = d.isBackward, w = E === void 0 ? !1 : E;
    f = f || Te(b), v();
    var O = null;
    if (o.tabbableGroups.length > 0) {
      var T = l(f, b), N = T >= 0 ? o.containerGroups[T] : void 0;
      if (T < 0) w ? O = o.tabbableGroups[o.tabbableGroups.length - 1].lastTabbableNode : O = o.tabbableGroups[0].firstTabbableNode;
      else if (w) {
        var A = o.tabbableGroups.findIndex(function(We) {
          var Ke = We.firstTabbableNode;
          return f === Ke;
        });
        if (A < 0 && (N.container === f || Ne(f, a.tabbableOptions) && !ae(f, a.tabbableOptions) && !N.nextTabbableNode(f, !1)) && (A = T), A >= 0) {
          var M = A === 0 ? o.tabbableGroups.length - 1 : A - 1, B = o.tabbableGroups[M];
          O = ee(f) >= 0 ? B.lastTabbableNode : B.lastDomTabbableNode;
        } else he(b) || (O = N.nextTabbableNode(f, !1));
      } else {
        var $ = o.tabbableGroups.findIndex(function(We) {
          var Ke = We.lastTabbableNode;
          return f === Ke;
        });
        if ($ < 0 && (N.container === f || Ne(f, a.tabbableOptions) && !ae(f, a.tabbableOptions) && !N.nextTabbableNode(f)) && ($ = T), $ >= 0) {
          var ze = $ === o.tabbableGroups.length - 1 ? 0 : $ + 1, J = o.tabbableGroups[ze];
          O = ee(f) >= 0 ? J.firstTabbableNode : J.firstDomTabbableNode;
        } else he(b) || (O = N.nextTabbableNode(f));
      }
    } else O = h("fallbackFocus");
    return O;
  }, x = function(d) {
    if (!(l(Te(d), d) >= 0)) {
      if (le(a.clickOutsideDeactivates, d)) {
        s.deactivate({ returnFocus: a.returnFocusOnDeactivate });
        return;
      }
      le(a.allowOutsideClick, d) || d.preventDefault();
    }
  }, C = function(d) {
    var f = Te(d), b = l(f, d) >= 0;
    if (b || f instanceof Document)
      b && (o.mostRecentlyFocusedNode = f);
    else {
      d.stopImmediatePropagation();
      var E, w = !0;
      if (o.mostRecentlyFocusedNode)
        if (ee(o.mostRecentlyFocusedNode) > 0) {
          var O = l(o.mostRecentlyFocusedNode), T = o.containerGroups[O].tabbableNodes;
          if (T.length > 0) {
            var N = T.findIndex(function(A) {
              return A === o.mostRecentlyFocusedNode;
            });
            N >= 0 && (a.isKeyForward(o.recentNavEvent) ? N + 1 < T.length && (E = T[N + 1], w = !1) : N - 1 >= 0 && (E = T[N - 1], w = !1));
          }
        } else o.containerGroups.some(function(A) {
          return A.tabbableNodes.some(function(M) {
            return ee(M) > 0;
          });
        }) || (w = !1);
      else w = !1;
      w && (E = m({
        target: o.mostRecentlyFocusedNode,
        isBackward: a.isKeyBackward(o.recentNavEvent)
      })), g(E || o.mostRecentlyFocusedNode || u());
    }
    o.recentNavEvent = void 0;
  }, _ = function(d) {
    var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    o.recentNavEvent = d;
    var b = m({
      event: d,
      isBackward: f
    });
    b && (he(d) && d.preventDefault(), g(b));
  }, L = function(d) {
    (a.isKeyForward(d) || a.isKeyBackward(d)) && _(d, a.isKeyBackward(d));
  }, I = function(d) {
    fi(d) && le(a.escapeDeactivates, d) !== !1 && (d.preventDefault(), s.deactivate());
  }, D = function(d) {
    l(Te(d), d) >= 0 || le(a.clickOutsideDeactivates, d) || le(a.allowOutsideClick, d) || (d.preventDefault(), d.stopImmediatePropagation());
  }, k = function() {
    if (!o.active) return Promise.resolve();
    K.activateTrap(i, s);
    var d;
    return a.delayInitialFocus ? d = new Promise(function(f) {
      o.delayInitialFocusTimer = kt(function() {
        g(u()), f();
      });
    }) : (d = Promise.resolve(), g(u())), n.addEventListener("focusin", C, !0), n.addEventListener("mousedown", x, {
      capture: !0,
      passive: !1
    }), n.addEventListener("touchstart", x, {
      capture: !0,
      passive: !1
    }), n.addEventListener("click", D, {
      capture: !0,
      passive: !1
    }), n.addEventListener("keydown", L, {
      capture: !0,
      passive: !1
    }), n.addEventListener("keydown", I), d;
  }, F = function(d) {
    o.active && !o.paused && s._setSubtreeIsolation(!1), o.adjacentElements.clear(), o.alreadySilent.clear();
    var f = /* @__PURE__ */ new Set(), b = /* @__PURE__ */ new Set(), E = Et(d), w;
    try {
      for (E.s(); !(w = E.n()).done; ) {
        var O = w.value;
        f.add(O);
        for (var T = typeof ShadowRoot < "u" && O.getRootNode() instanceof ShadowRoot, N = O; N; ) {
          f.add(N);
          var A = N.parentElement, M = [];
          A ? M = A.children : !A && T && (M = N.getRootNode().children, A = N.getRootNode().host, T = typeof ShadowRoot < "u" && A.getRootNode() instanceof ShadowRoot);
          var B = Et(M), $;
          try {
            for (B.s(); !($ = B.n()).done; ) {
              var ze = $.value;
              b.add(ze);
            }
          } catch (J) {
            B.e(J);
          } finally {
            B.f();
          }
          N = A;
        }
      }
    } catch (J) {
      E.e(J);
    } finally {
      E.f();
    }
    f.forEach(function(J) {
      b.delete(J);
    }), o.adjacentElements = b;
  }, U = function() {
    if (o.active)
      return n.removeEventListener("focusin", C, !0), n.removeEventListener("mousedown", x, !0), n.removeEventListener("touchstart", x, !0), n.removeEventListener("click", D, !0), n.removeEventListener("keydown", L, !0), n.removeEventListener("keydown", I), s;
  }, W = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(function(d) {
    d.some(function(f) {
      return Array.from(f.removedNodes).some(function(b) {
        return b === o.mostRecentlyFocusedNode;
      });
    }) && g(u());
  }) : void 0, P = function() {
    W && (W.disconnect(), o.active && !o.paused && o.containers.map(function(d) {
      W.observe(d, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return s = {
    get active() {
      return o.active;
    },
    get paused() {
      return o.paused;
    },
    activate: function(d) {
      if (o.active) return this;
      var f = c(d, "onActivate"), b = c(d, "onPostActivate"), E = c(d, "checkCanFocusTrap"), w = K.getActiveTrap(i), O = !1;
      if (w && !w.paused) {
        var T;
        (T = w._setSubtreeIsolation) === null || T === void 0 || T.call(w, !1), O = !0;
      }
      try {
        E || v(), o.active = !0, o.paused = !1, o.nodeFocusedBeforeActivation = p(n), f?.();
        var N = /* @__PURE__ */ (function() {
          var M = xt(/* @__PURE__ */ fe().m(function B() {
            return fe().w(function($) {
              for (; ; ) switch ($.n) {
                case 0:
                  return E && v(), $.n = 1, k();
                case 1:
                  s._setSubtreeIsolation(!0), P(), b?.();
                case 2:
                  return $.a(2);
              }
            }, B);
          }));
          return function() {
            return M.apply(this, arguments);
          };
        })();
        if (E)
          return E(o.containers.concat()).then(N, N), this;
        N();
      } catch (M) {
        if (w === K.getActiveTrap(i) && O) {
          var A;
          (A = w._setSubtreeIsolation) === null || A === void 0 || A.call(w, !0);
        }
        throw M;
      }
      return this;
    },
    deactivate: function(d) {
      if (!o.active) return this;
      var f = Tt({
        onDeactivate: a.onDeactivate,
        onPostDeactivate: a.onPostDeactivate,
        checkCanReturnFocus: a.checkCanReturnFocus
      }, d);
      clearTimeout(o.delayInitialFocusTimer), o.delayInitialFocusTimer = void 0, o.paused || s._setSubtreeIsolation(!1), o.alreadySilent.clear(), U(), o.active = !1, o.paused = !1, P(), K.deactivateTrap(i, s);
      var b = c(f, "onDeactivate"), E = c(f, "onPostDeactivate"), w = c(f, "checkCanReturnFocus"), O = c(f, "returnFocus", "returnFocusOnDeactivate");
      b?.();
      var T = function() {
        kt(function() {
          O && g(y(o.nodeFocusedBeforeActivation)), E?.();
        });
      };
      return O && w ? (w(y(o.nodeFocusedBeforeActivation)).then(T, T), this) : (T(), this);
    },
    pause: function(d) {
      return o.active ? (o.manuallyPaused = !0, this._setPausedState(!0, d)) : this;
    },
    unpause: function(d) {
      return o.active ? (o.manuallyPaused = !1, i[i.length - 1] !== this ? this : this._setPausedState(!1, d)) : this;
    },
    updateContainerElements: function(d) {
      return o.containers = [].concat(d).filter(Boolean).map(function(f) {
        return typeof f == "string" ? n.querySelector(f) : f;
      }), a.isolateSubtrees && F(o.containers), o.active && (v(), o.paused || s._setSubtreeIsolation(!0)), P(), this;
    }
  }, Object.defineProperties(s, {
    _isManuallyPaused: { value: function() {
      return o.manuallyPaused;
    } },
    _setPausedState: { value: function(d, f) {
      if (o.paused === d) return this;
      if (o.paused = d, d) {
        var b = c(f, "onPause"), E = c(f, "onPostPause");
        b?.(), U(), s._setSubtreeIsolation(!1), P(), E?.();
      } else {
        var w = c(f, "onUnpause"), O = c(f, "onPostUnpause");
        w?.(), (/* @__PURE__ */ (function() {
          var T = xt(/* @__PURE__ */ fe().m(function N() {
            return fe().w(function(A) {
              for (; ; ) switch (A.n) {
                case 0:
                  return v(), A.n = 1, k();
                case 1:
                  s._setSubtreeIsolation(!0), P(), O?.();
                case 2:
                  return A.a(2);
              }
            }, N);
          }));
          return function() {
            return T.apply(this, arguments);
          };
        })())();
      }
      return this;
    } },
    _setSubtreeIsolation: { value: function(d) {
      a.isolateSubtrees && o.adjacentElements.forEach(function(f) {
        var b;
        d ? a.isolateSubtrees === "aria-hidden" ? ((f.ariaHidden === "true" || ((b = f.getAttribute("aria-hidden")) === null || b === void 0 ? void 0 : b.toLowerCase()) === "true") && o.alreadySilent.add(f), f.setAttribute("aria-hidden", "true")) : ((f.inert || f.hasAttribute("inert")) && o.alreadySilent.add(f), f.setAttribute("inert", !0)) : o.alreadySilent.has(f) || (a.isolateSubtrees === "aria-hidden" ? f.removeAttribute("aria-hidden") : f.removeAttribute("inert"));
      });
    } }
  }), s.updateContainerElements(t), s;
};
function gi(e) {
  let t, r;
  window.addEventListener("focusin", () => {
    t = r, r = document.activeElement;
  }), e.magic("focus", (n) => {
    let i = n;
    return {
      __noscroll: !1,
      __wrapAround: !1,
      within(a) {
        return i = a, this;
      },
      withoutScrolling() {
        return this.__noscroll = !0, this;
      },
      noscroll() {
        return this.__noscroll = !0, this;
      },
      withWrapAround() {
        return this.__wrapAround = !0, this;
      },
      wrap() {
        return this.withWrapAround();
      },
      focusable(a) {
        return Ne(a);
      },
      previouslyFocused() {
        return t;
      },
      lastFocused() {
        return t;
      },
      focused() {
        return r;
      },
      focusables() {
        return Array.isArray(i) ? i : lr(i, { displayCheck: "none" });
      },
      all() {
        return this.focusables();
      },
      isFirst(a) {
        let o = this.all();
        return o[0] && o[0].isSameNode(a);
      },
      isLast(a) {
        let o = this.all();
        return o.length && o.slice(-1)[0].isSameNode(a);
      },
      getFirst() {
        return this.all()[0];
      },
      getLast() {
        return this.all().slice(-1)[0];
      },
      getNext() {
        let a = this.all(), o = document.activeElement;
        if (a.indexOf(o) !== -1)
          return this.__wrapAround && a.indexOf(o) === a.length - 1 ? a[0] : a[a.indexOf(o) + 1];
      },
      getPrevious() {
        let a = this.all(), o = document.activeElement;
        if (a.indexOf(o) !== -1)
          return this.__wrapAround && a.indexOf(o) === 0 ? a.slice(-1)[0] : a[a.indexOf(o) - 1];
      },
      first() {
        this.focus(this.getFirst());
      },
      last() {
        this.focus(this.getLast());
      },
      next() {
        this.focus(this.getNext());
      },
      previous() {
        this.focus(this.getPrevious());
      },
      prev() {
        return this.previous();
      },
      focus(a) {
        a && setTimeout(() => {
          a.hasAttribute("tabindex") || a.setAttribute("tabindex", "0"), a.focus({ preventScroll: this.__noscroll });
        });
      }
    };
  }), e.directive("trap", e.skipDuringClone((n, { expression: i, modifiers: a }, { effect: o, evaluateLater: s, cleanup: c }) => {
    let l = s(i), h = !1, u = {
      escapeDeactivates: !1,
      allowOutsideClick: !0,
      fallbackFocus: () => n
    }, v = () => {
    };
    if (a.includes("noautofocus")) u.initialFocus = !1;
    else {
      let m = n.querySelector("[autofocus]");
      m && (u.initialFocus = m);
    }
    a.includes("inert") && (u.onPostActivate = () => {
      e.nextTick(() => {
        v = Nt(n);
      });
    });
    let p = mi(n, u), g = () => {
    };
    const y = () => {
      v(), v = () => {
      }, g(), g = () => {
      }, p.deactivate({ returnFocus: !a.includes("noreturn") });
    };
    o(() => l((m) => {
      h !== m && (m && !h && (a.includes("noscroll") && (g = bi()), setTimeout(() => {
        p.activate();
      }, 15)), !m && h && y(), h = !!m);
    })), c(y);
  }, (n, { expression: i, modifiers: a }, { evaluate: o }) => {
    a.includes("inert") && o(i) && Nt(n);
  }));
}
function Nt(e) {
  let t = [];
  return dr(e, (r) => {
    let n = r.hasAttribute("aria-hidden");
    r.setAttribute("aria-hidden", "true"), t.push(() => n || r.removeAttribute("aria-hidden"));
  }), () => {
    for (; t.length; ) t.pop()();
  };
}
function dr(e, t) {
  e.isSameNode(document.body) || !e.parentNode || Array.from(e.parentNode.children).forEach((r) => {
    r.isSameNode(e) ? dr(e.parentNode, t) : t(r);
  });
}
function bi() {
  let e = document.documentElement.style.overflow, t = document.documentElement.style.paddingRight, r = window.innerWidth - document.documentElement.clientWidth, n = window.getComputedStyle(document.documentElement).scrollbarGutter;
  return document.documentElement.style.overflow = "hidden", n && n !== "auto" ? () => {
    document.documentElement.style.overflow = e;
  } : (document.documentElement.style.paddingRight = `${r}px`, () => {
    document.documentElement.style.overflow = e, document.documentElement.style.paddingRight = t;
  });
}
var yi = gi;
function wi(e) {
  e.directive("intersect", e.skipDuringClone((t, { value: r, expression: n, modifiers: i }, { evaluateLater: a, cleanup: o }) => {
    let s = a(n), c = {
      rootMargin: Si(i),
      threshold: xi(i)
    }, l = new IntersectionObserver((h) => {
      h.forEach((u) => {
        u.isIntersecting !== (r === "leave") && (s(), i.includes("once") && l.disconnect());
      });
    }, c);
    l.observe(t), o(() => {
      l.disconnect();
    });
  }));
}
function xi(e) {
  if (e.includes("full")) return 0.99;
  if (e.includes("half")) return 0.5;
  if (!e.includes("threshold")) return 0;
  let t = e[e.indexOf("threshold") + 1];
  return t === "100" ? 1 : t === "0" ? 0 : +`.${t}`;
}
function Ei(e) {
  let t = e.match(/^(-?[0-9]+)(px|%)?$/);
  return t ? t[1] + (t[2] || "px") : void 0;
}
function Si(e) {
  const t = "margin", r = "0px 0px 0px 0px", n = e.indexOf(t);
  if (n === -1) return r;
  let i = [];
  for (let a = 1; a < 5; a++) i.push(Ei(e[n + a] || ""));
  return i = i.filter((a) => a !== void 0), i.length ? i.join(" ").trim() : r;
}
var Ti = wi;
function it(e, t, r) {
  hr();
  let n = fr(r), i = typeof t == "string" ? Oi(t) : t;
  return window.Alpine && window.Alpine.closestDataStack && !e._x_dataStack && (i._x_dataStack = window.Alpine.closestDataStack(e), i._x_dataStack && window.Alpine.cloneNode(e, i)), n.patch(e, i), e;
}
function ki(e, t, r, n = {}) {
  hr();
  let i = fr(n), a = e.parentNode, o = new pe(e, t), s = typeof r == "string" ? (() => {
    let u = document.createElement("div");
    return u.insertAdjacentHTML("beforeend", r), u;
  })() : r, c = document.createComment("[morph-start]"), l = document.createComment("[morph-end]");
  s.insertBefore(c, s.firstChild), s.appendChild(l);
  let h = new pe(c, l);
  window.Alpine && window.Alpine.closestDataStack && (s._x_dataStack = window.Alpine.closestDataStack(a), s._x_dataStack && window.Alpine.cloneNode(a, s)), i.patchChildren(o, h);
}
function fr(e = {}) {
  let t = (i) => i.getAttribute("key"), r = () => {
  }, n = {
    key: e.key || t,
    lookahead: e.lookahead || !1,
    updating: e.updating || r,
    updated: e.updated || r,
    removing: e.removing || r,
    removed: e.removed || r,
    adding: e.adding || r,
    added: e.added || r
  };
  return n.patch = function(i, a) {
    if (n.differentElementNamesTypesOrKeys(i, a)) return n.swapElements(i, a);
    let o = !1, s = !1, c = (l) => n.skipUntilCondition = l;
    if (!Ni(n.updating, () => s = !0, c, i, a, () => o = !0)) {
      if (i.nodeType === 1 && window.Alpine && (window.Alpine.cloneNode(i, a), i._x_teleport && a._x_teleport && n.patch(i._x_teleport, a._x_teleport)), Ci(a)) {
        n.patchNodeValue(i, a), n.updated(i, a);
        return;
      }
      o || n.patchAttributes(i, a), n.updated(i, a), s || n.patchChildren(i, a);
    }
  }, n.differentElementNamesTypesOrKeys = function(i, a) {
    return i.nodeType != a.nodeType || i.nodeName != a.nodeName || n.getKey(i) != n.getKey(a);
  }, n.swapElements = function(i, a) {
    if (ue(n.removing, i)) return;
    let o = a.cloneNode(!0);
    ue(n.adding, o) || (i.replaceWith(o), n.removed(i), n.added(o));
  }, n.patchNodeValue = function(i, a) {
    let o = a.nodeValue;
    i.nodeValue !== o && (i.nodeValue = o);
  }, n.patchAttributes = function(i, a) {
    if (i._x_transitioning || i._x_isShown && !a._x_isShown || !i._x_isShown && a._x_isShown) return;
    let o = Array.from(i.attributes), s = Array.from(a.attributes);
    for (let c = o.length - 1; c >= 0; c--) {
      let l = o[c].name;
      a.hasAttribute(l) || (l === "open" && i.nodeName === "DIALOG" && i.open ? i.close() : i.removeAttribute(l));
    }
    for (let c = s.length - 1; c >= 0; c--) {
      let l = s[c].name, h = s[c].value;
      i.getAttribute(l) !== h && i.setAttribute(l, h);
    }
  }, n.patchChildren = function(i, a) {
    let o = n.keyToMap(i.children), s = {}, c = Ct(a), l = Ct(i);
    for (; c; ) {
      _i(c, l);
      let u = n.getKey(c), v = n.getKey(l);
      if (n.skipUntilCondition) {
        let m = !l || n.skipUntilCondition(l), x = !c || n.skipUntilCondition(c);
        if (m && x) n.skipUntilCondition = null;
        else {
          m || (l = l && j(i, l)), x || (c = c && j(a, c));
          continue;
        }
      }
      if (!l) if (u && s[u]) {
        let m = s[u];
        i.appendChild(m), l = m, v = n.getKey(l);
      } else {
        if (!ue(n.adding, c)) {
          let m = c.cloneNode(!0);
          i.appendChild(m), n.added(m);
        }
        c = j(a, c);
        continue;
      }
      let p = (m) => m && m.nodeType === 8 && m.textContent === "[if BLOCK]><![endif]", g = (m) => m && m.nodeType === 8 && m.textContent === "[if ENDBLOCK]><![endif]";
      if (p(c) && p(l)) {
        let m = 0, x = l;
        for (; l; ) {
          let k = j(i, l);
          if (p(k)) m++;
          else if (g(k) && m > 0) m--;
          else if (g(k) && m === 0) {
            l = k;
            break;
          }
          l = k;
        }
        let C = l;
        m = 0;
        let _ = c;
        for (; c; ) {
          let k = j(a, c);
          if (p(k)) m++;
          else if (g(k) && m > 0) m--;
          else if (g(k) && m === 0) {
            c = k;
            break;
          }
          c = k;
        }
        let L = c, I = new pe(x, C), D = new pe(_, L);
        n.patchChildren(I, D);
        continue;
      }
      if (l.nodeType === 1 && n.lookahead && !l.isEqualNode(c)) {
        let m = j(a, c), x = !1;
        for (; !x && m; )
          m.nodeType === 1 && l.isEqualNode(m) && (x = !0, l = n.addNodeBefore(i, c, l), v = n.getKey(l)), m = j(a, m);
      }
      if (u !== v) {
        if (!u && v) {
          s[v] = l, l = n.addNodeBefore(i, c, l), s[v].remove(), l = j(i, l), c = j(a, c);
          continue;
        }
        if (u && !v && o[u] && (l.replaceWith(o[u]), l = o[u], v = n.getKey(l)), u && v) {
          let m = o[u];
          if (m)
            s[v] = l, l.replaceWith(m), l = m, v = n.getKey(l);
          else {
            s[v] = l, l = n.addNodeBefore(i, c, l), s[v].remove(), l = j(i, l), c = j(a, c);
            continue;
          }
        }
      }
      let y = l && j(i, l);
      n.patch(l, c), c = c && j(a, c), l = y;
    }
    let h = [];
    for (; l; )
      ue(n.removing, l) || h.push(l), l = j(i, l);
    for (; h.length; ) {
      let u = h.shift();
      u.remove(), n.removed(u);
    }
  }, n.getKey = function(i) {
    return i && i.nodeType === 1 && n.key(i);
  }, n.keyToMap = function(i) {
    let a = {};
    for (let o of i) {
      let s = n.getKey(o);
      s && (a[s] = o);
    }
    return a;
  }, n.addNodeBefore = function(i, a, o) {
    if (!ue(n.adding, a)) {
      let s = a.cloneNode(!0);
      return i.insertBefore(s, o), n.added(s), s;
    }
    return a;
  }, n;
}
it.step = () => {
};
it.log = () => {
};
function ue(e, ...t) {
  let r = !1;
  return e(...t, () => r = !0), r;
}
function Ni(e, t, r, ...n) {
  let i = !1;
  return e(...n, () => i = !0, t, r), i;
}
var Ot = !1;
function Oi(e) {
  const t = document.createElement("template");
  return t.innerHTML = e, t.content.firstElementChild;
}
function Ci(e) {
  return e.nodeType === 3 || e.nodeType === 8;
}
var pe = class {
  constructor(e, t) {
    this.startComment = e, this.endComment = t;
  }
  get children() {
    let e = [], t = this.startComment.nextSibling;
    for (; t && t !== this.endComment; )
      e.push(t), t = t.nextSibling;
    return e;
  }
  appendChild(e) {
    this.endComment.before(e);
  }
  get firstChild() {
    let e = this.startComment.nextSibling;
    if (e !== this.endComment)
      return e;
  }
  nextNode(e) {
    let t = e.nextSibling;
    if (t !== this.endComment)
      return t;
  }
  insertBefore(e, t) {
    return t.before(e), e;
  }
};
function Ct(e) {
  return e.firstChild;
}
function j(e, t) {
  let r;
  return e instanceof pe ? r = e.nextNode(t) : r = t.nextSibling, r;
}
function hr() {
  if (Ot) return;
  Ot = !0;
  let e = Element.prototype.setAttribute, t = document.createElement("div");
  Element.prototype.setAttribute = function(n, i) {
    if (!n.includes("@")) return e.call(this, n, i);
    t.innerHTML = `<span ${n}="${i.replace(/&/g, "&amp;").replace(/"/g, "&quot;")}"></span>`;
    let a = t.firstElementChild.getAttributeNode(n);
    t.firstElementChild.removeAttributeNode(a), this.setAttributeNode(a);
  };
}
function _i(e, t) {
  let r = t && t._x_bindings && t._x_bindings.id;
  r && e.setAttribute && (e.setAttribute("id", r), e.id = r);
}
function Ai(e) {
  e.morph = it, e.morphBetween = ki;
}
var Fi = Ai, Ii = (e, t) => {
  let r;
  const n = /* @__PURE__ */ new Set();
  return function(i, a) {
    r && clearTimeout(r), i.forEach(({ target: o }) => n.add(o)), r = setTimeout(() => {
      e(n, a), r = null;
    }, t);
  };
}, Li = (e) => {
  e.forEach((t) => Ri(t)), e.clear();
}, Ri = (e) => {
  const t = (o) => e.setAttribute("sizes", (o | 0) + "px");
  let r = 0, n = 0, i = e;
  for (; r < 100 && i; )
    r = i.offsetWidth, n = i.offsetHeight, i = i.parentNode;
  if (getComputedStyle(e).objectFit !== "cover") return t(r);
  const a = Number(e.getAttribute("width")) / Number(e.getAttribute("height"));
  if (!a || r / n >= a + 0.1) return t(r);
  t(n * a);
}, Q = new ResizeObserver(Ii(Li, 800)), _t = (e, t, r) => {
  if (t) return $i(e);
  if (r) return Di(e, r);
  throw new TypeError("Invalid options");
}, Di = (e, t) => (e = new URL(e, document.baseURI).href, e.includes("localhost") ? () => e : (r) => (t + e).replace("{width}", String(r))), $i = (e) => {
  if (e.includes("{width}")) return (t) => e.replaceAll("{width}", String(t));
  if (Ft.test(e)) {
    const t = e.replace(Ft, "_{width}x$1");
    return (r) => t.replaceAll("{width}", String(r));
  }
  return (t) => {
    const r = new URL(e, document.baseURI);
    return r.searchParams.set("width", String(t)), r.href;
  };
}, Pi = [
  180,
  360,
  540,
  720,
  900,
  1080,
  1296,
  1512,
  1728,
  1944,
  2160,
  2376,
  2592,
  2808,
  3024
], At = (e, t = 1 / 0) => Pi.filter((r) => r <= t).map((r) => `${e(r)} ${r}w`).join(","), Ft = /_\d+x(\.jpg|\.png)/;
function Mi(e) {
  const { autoSize: t = !0, shopify: r = !1, maxSize: n = 0, cloudURL: i = "" } = ji(e) ?? {};
  return (a) => {
    a.directive("rias", (s, { expression: c }, { effect: l, evaluateLater: h, cleanup: u }) => {
      if (!(s instanceof HTMLImageElement)) return console.warn("x-rias only works on img elements");
      if (u(() => Q.unobserve(s)), !c) return t && Q.observe(s);
      const v = h(c);
      l(() => {
        v((p) => {
          if (!p || typeof p != "string") return;
          const g = _t(p, r, i), y = n || Number(s.dataset.maxSize) || 1 / 0, m = g(Math.min(y, 360)), x = At(g, y);
          a.mutateDom(() => {
            s.src = m, s.srcset = x, s.loading = s.loading == "eager" ? "eager" : "lazy", (t || s.dataset.sizes == "auto") && Q.observe(s);
          });
        });
      });
    });
    const o = {
      srcset(s) {
        return At(_t(s, r, i), n || 1 / 0);
      },
      observe: Q.observe.bind(Q),
      unobserve: Q.unobserve.bind(Q)
    };
    a.magic("rias", () => o);
  };
}
var ji = (e) => {
  if (typeof e == "string") return { cloudURL: `https://res.cloudinary.com/${e}/image/fetch/f_auto,q_80,w_{width}/` };
  if (typeof e == "object") return {
    ...e,
    cloudURL: e.key ? `https://res.cloudinary.com/${e.key}/image/fetch/f_auto,q_80,w_{width}/` : ""
  };
}, Bi = (e) => {
  e.addRootSelector(() => `[${e.prefixed("data-async")}]`);
  const t = "data-async", r = e.prefixed("ignore"), n = {}, i = /* @__PURE__ */ new WeakSet(), a = (o, { expression: s }, { evaluateLater: c, evaluate: l, cleanup: h }) => {
    i.has(o) || (i.add(o), c(s)((u) => {
      if (typeof u != "object" || u === null) throw new Error(`alpine.js Async directive expected an object, but received: ${typeof u}`);
      [!0, void 0].includes(u) && (u = {});
      const v = e.reactive(u), p = e.addScopeToNode(o, v);
      v.init && l(v.init), h(() => {
        v.destroy && l(v.destroy), p();
      }), delete o._x_ignore, o.removeAttribute(r), e.initTree(o);
    }, { scope: n }));
  };
  a.inline = (o, { expression: s }) => {
    i.has(o) || (o._x_ignore = !0, o.setAttribute(r, ""));
  }, e.directive(t, a).before("ignore"), e.asyncData = (o, s) => {
    n[o] = async (...c) => {
      const [l, h] = s.split("?");
      try {
        const u = await import(l);
        if (h && h in u) return u[h](...c);
        if (o in u) return u[o](...c);
        if (u.default && typeof u.default == "function") return u.default(...c);
        if (typeof u == "function") return u(...c);
        throw new Error(`Async Data: Module ${s} does not export a function named ${o}, or a default function.`);
      } catch (u) {
        return console.error("Async Data Loader Error while looking for:", o, s), console.error(u), {};
      }
    };
  };
}, Hi = (e) => {
  e.directive("clickable", (n, { expression: i }, { cleanup: a }) => {
    const o = n.querySelector(i || "a, button");
    if (!o) return console.warn(`x-clickable: No target found for selector ${i || "a, button"}`);
    const s = function(c) {
      const l = c.target;
      !(l instanceof HTMLElement) || t(l, n) !== n || r(o, c.constructor, c);
    };
    a(e.bind(n, {
      "@click": s,
      "@auxclick": s
    }));
  });
  const t = (n, i) => e.findClosest(n, (a) => a.matches("a, button, input, select") || a === i), r = (n, i = MouseEvent, a) => n.dispatchEvent(new i("click", a));
}, Oe = /* @__PURE__ */ (function(e) {
  return e.Up = "up", e.Down = "down", e;
})(Oe || {}), qi = (e) => {
  const t = /* @__PURE__ */ new Set(), r = e.reactive({
    previous: window.scrollY,
    current: window.scrollY,
    nearTop: window.scrollY < 120,
    direction: Oe.Up,
    onScroll: (i) => (t.add(i), () => t.delete(i))
  });
  let n;
  r.onScroll((i) => {
    const a = i.current > i.previous ? Oe.Down : Oe.Up;
    a !== r.direction ? n ??= setTimeout(() => r.direction = a, 200) : (clearTimeout(n), n = void 0);
  }), window.addEventListener("scroll", () => {
    r.previous = r.current, r.current = window.scrollY, r.nearTop = window.scrollY <= 90 ? !0 : window.scrollY >= 120 ? !1 : r.nearTop, t.forEach((i) => i(r));
  }, { passive: !0 }), e.$scroll = r, e.magic("scroll", () => r);
}, R = /* @__PURE__ */ Symbol("$slider"), vr = (e) => R in e, Vi = {
  ":disabled"() {
    return this[R].isLast;
  },
  "x-on:click"() {
    this[R].next();
  }
}, Ui = {
  ":disabled"() {
    return this[R].isFirst;
  },
  "x-on:click"() {
    this[R].prev();
  }
}, zi = (e) => ({
  ":disabled"() {
    return this[R].focusedIndex === e;
  },
  "x-on:click"() {
    this[R].scrollTo(e);
  }
}), Wi = {
  "x-on:mouseenter"() {
    this[R].pause();
  },
  "x-on:mouseleave"() {
    this[R].unpause();
  },
  "x-on:focusin"() {
    this[R].pause();
  },
  "x-on:focusout"() {
    this[R].unpause();
  }
}, Ki = { ":style"() {
  const e = this[R].focusedSize;
  return {
    maxHeight: e ? `${e}px` : "max-content",
    transition: "max-height 300ms"
  };
} }, Gi = {
  "x-intersect.threshold.60"() {
    this[R].handleIntersect(this.$el);
  },
  "x-init"() {
    this[R].onLoad(this.$el);
  },
  "x-on:load"() {
    this[R].onLoad(this.$el);
  },
  ":class"() {
    const e = this[R], t = e.indexOfItem(this.$el) ?? 0, r = e.focusedIndex;
    if (t > r) return "slide-item slide-next";
    if (t < r) return "slide-item slide-previous";
    if (t == r) return "slide-item slide-current";
  }
}, Yi = {
  "x-intersect:enter.threshold.60"() {
    this.$el.removeAttribute("tabindex"), this.$el.removeAttribute("inert");
  },
  "x-intersect:leave.threshold.40"() {
    this.$el.setAttribute("tabindex", "-1"), this.$el.setAttribute("inert", "inert");
  }
}, Ji = (e, t, r, { Alpine: n }) => {
  const i = n.$data(t);
  vr(i) ? i[R].components.set(e, t) : console.error(`Element with ${r.original} needs to be inside an x-slider element`, t);
}, oe = (e) => Array.from(e.children).flatMap((t) => getComputedStyle(t).display === "contents" ? oe(t) : t).filter((t) => t.nodeName !== "TEMPLATE" && getComputedStyle(t).display !== "none"), Xi = (e) => e instanceof HTMLImageElement, Zi = (e, { expression: t }, { evaluate: r, cleanup: n, Alpine: i }) => {
  const a = [];
  n(() => a.forEach((c) => c()));
  const o = Object.assign({
    scrollToDepth: 0,
    intoView: !1,
    centerVertically: !1,
    autoScroll: 0,
    autoInitialize: !1,
    animated: !1
  }, t ? r(t) : {}), s = i.reactive({
    focusedIndex: 0,
    focusedSize: 0,
    initialized: !!o.autoInitialize,
    touched: !1,
    paused: !1,
    pause() {
      return this.paused = !0, this;
    },
    unpause() {
      return this.paused = !1, this;
    },
    components: /* @__PURE__ */ new Map(),
    autoScrollPercentage: 1,
    init() {
      if (o.autoScroll) {
        const c = new Qi(o.autoScroll).onTick((l) => {
          this.autoScrollPercentage = l;
        }).onFinish(() => {
          if (this.touched) return c.abort();
          if (this.paused) return;
          const l = this.components.get("gallery");
          l && this.scrollTo(Cr(this.focusedIndex + 1, oe(l).length));
        });
        a.push(() => c.abort());
      }
    },
    onLoad(c) {
      if (this.initialized || Xi(c) && !c.complete) return;
      this.focusedIndex = 0, this.focusedSize = this.itemAtIndex(0)?.clientHeight || 0;
      const l = this.components.get("gallery");
      l && (l.scrollLeft = 0), this.initialized = !0, this.init();
    },
    handleIntersect(c) {
      this.initialized && (this.focusedIndex = this.indexOfItem(c) ?? 0, this.focusedSize = c.clientHeight);
    },
    itemAtIndex(c) {
      const l = this.components.get("gallery");
      if (!l) return;
      const h = oe(l);
      let u = h[kr(c, h.length - 1)];
      if (u !== void 0) {
        for (let v = 0; v < o.scrollToDepth; v++) u = u?.firstElementChild ?? u;
        return u?.closest("template") ? this.itemAtIndex(c + 1) : u;
      }
    },
    indexOfItem(c) {
      const l = this.components.get("gallery");
      if (!l) return;
      const h = oe(l);
      for (let u = 0; u < h.length; u++) if (h[u].contains(c)) return u;
    },
    async scrollTo(c, l = 0, h = !1, u = !1) {
      const v = this.components.get("gallery");
      if (!v) return;
      const p = c instanceof Element ? c : this.itemAtIndex(c);
      if (!p) return;
      h && (this.touched = !0);
      const g = typeof c == "number" ? c : this.indexOfItem(p) ?? this.focusedIndex;
      this.initialized || (this.initialized = !0, await Or()), u || o.animated ? this.focusedIndex = g : this.focusedIndex += Math.sign(g - this.focusedIndex), o.animated || (window.scrollBy({ top: 0.5 }), window.scrollBy({ top: -0.5 }), o.intoView ? p.scrollIntoView({
        behavior: "smooth",
        block: o.centerVertically ? "center" : "nearest",
        inline: "center"
      }) : (u && (v.style.scrollBehavior = "auto"), v.scrollLeft = c === 0 ? 0 : (ot(HTMLElement, p)?.offsetLeft ?? 0) - l, u && (v.style.scrollBehavior = null)));
      const y = this.components.get("thumbnails");
      if (!y) return;
      const m = ot(HTMLElement, y.children[g]);
      m && y.scrollTo({
        top: m.offsetTop - (y.clientHeight - m.clientHeight) / 2,
        left: m.offsetLeft - (y.clientWidth - m.clientWidth) / 2,
        behavior: "smooth"
      });
    },
    get isFirst() {
      return this.focusedIndex === 0;
    },
    get isLast() {
      const c = this.components.get("gallery");
      return c ? this.focusedIndex === oe(c).length - 1 : !0;
    },
    get itemCount() {
      const c = this.components.get("gallery");
      return c ? oe(c).length : 0;
    },
    next() {
      this.scrollTo(this.focusedIndex + 1);
    },
    prev() {
      this.scrollTo(this.focusedIndex - 1);
    }
  });
  i.addScopeToNode(e, { [R]: s }), o.autoInitialize && s.init();
}, Qi = class pr extends EventTarget {
  duration = 0;
  currentTime = 0;
  lastTimestep = 0;
  controller = new AbortController();
  get percentage() {
    return this.currentTime / this.duration;
  }
  constructor(t) {
    super(), this.duration = t, this.lastTimestep = performance.now(), requestAnimationFrame(this.ticker);
  }
  ticker = (t) => {
    if (this.controller.signal.aborted) return;
    const r = t - this.lastTimestep;
    this.lastTimestep = t, this.currentTime += r, this.dispatchEvent(new Event("tick")), this.currentTime > this.duration && (this.dispatchEvent(new Event("just-finished")), this.currentTime %= this.duration), requestAnimationFrame(this.ticker);
  };
  abort() {
    this.controller.abort();
  }
  onTick(t) {
    return this.addEventListener("tick", () => t(this.percentage), { signal: this.controller.signal }), this;
  }
  onFinish(t) {
    return this.addEventListener("just-finished", t, { signal: this.controller.signal }), this;
  }
  static fromSeconds(t) {
    return new pr(t * 1e3);
  }
}, ea = (e) => {
  e.addRootSelector(() => `[${e.prefixed("slider")}]`), e.directive("slider", (t, r, n) => {
    if (!r.value || r.value === "root") return Zi(t, r, n);
    (r.value === "gallery" || r.value === "thumbnails") && Ji(r.value, t, r, n);
  }), e.magic("slider", (t) => {
    const r = e.$data(t);
    if (vr(r)) return r[R];
  }), e.bind("$sliderDynamicHeight", Ki), e.bind("$sliderItem", Gi), e.bind("$sliderNext", Vi), e.bind("$sliderPrev", Ui), e.bind("$sliderGoTo", zi), e.bind("$sliderPause", Wi), e.bind("$sliderUnfocusHidden", Yi);
}, It = (e, t, r = t) => {
  const { scrollPaddingTop: n, scrollPaddingBottom: i } = window.getComputedStyle(e);
  return {
    top: Lt(n, t),
    bottom: Lt(i, r)
  };
}, Lt = (e, t) => e !== "auto" ? parseInt(e) : t, ta = 100, ra = (e) => {
  e.addRootSelector(() => `[${e.prefixed("smartstick")}]`), e.directive("smartstick", (t, r, { cleanup: n }) => {
    let i = It(t, ta);
    const a = e.reactive({
      top: 0,
      get topString() {
        return `${-1 * this.top + i.top}px`;
      }
    });
    let o = 0, s = window.scrollY;
    const c = () => {
      const g = window.scrollY, y = g - s;
      a.top = Math.min(o, Math.max(0, a.top + y)), s = g;
    }, l = () => {
      i = It(t, i.top, i.bottom), o = Math.max(0, t.clientHeight - window.innerHeight + i.top + i.bottom);
    }, h = new ResizeObserver(l);
    h.observe(t), window.addEventListener("resize", l);
    const u = window.matchMedia("(min-width: 1024px)"), v = (g) => window[g.matches ? "addEventListener" : "removeEventListener"]("scroll", c, { passive: !0 });
    u.addEventListener("change", v), v(u);
    const p = e.effect(() => t.style.top = a.topString);
    n(() => {
      e.release(p), h.disconnect(), u.removeEventListener("change", v), window.removeEventListener("resize", l), window.removeEventListener("scroll", c);
    });
  });
}, at = (e, t, r) => {
  const n = /* @__PURE__ */ new WeakMap();
  return (i) => {
    const a = (o) => {
      const s = i.findClosest(o, n.has.bind(n));
      if (!s) return console.error(`Could not find root for ${e} component`, o);
      if (s instanceof HTMLElement) return n.get(s);
    };
    i.magic(e, (o) => a(o)), i.directive(e, (o, s, c) => {
      if (!s.value) return n.set(o, t(o, s, c));
      const l = a(o);
      if (!l) return ia(e, o);
      (r?.[s.value] || na(e))(l, o, s, c);
    });
  };
}, na = (e) => (t, r, n) => {
  console.error(`Alpine ${e}: Invalid directive value`, r, n.original);
}, ia = (e, t) => console.error(`Could not find root for ${e} component`, t), Ce = /* @__PURE__ */ new WeakMap(), aa = (e, t) => {
  const r = t.findClosest(e, Ce.has.bind(Ce));
  if (r instanceof HTMLElement) return Ce.get(r);
}, oa = (e, t, { Alpine: r, effect: n }) => {
  const i = r.reactive({
    active: null,
    id: 0,
    addAccordion(a) {
      const o = this.id++, s = r.reactive({ active: a });
      return n(() => {
        s.active ? this.active = o : this.active === o && (this.active = null);
      }), n(() => {
        this.active === o ? s.active = !0 : s.active = !1;
      }), s;
    }
  });
  return Ce.set(e, i), i;
}, sa = (e) => e.directive("accordion-group", oa), ca = (e, { modifiers: [t = "closed"] }, { Alpine: r }) => aa(e, r)?.addAccordion(t === "open") ?? r.reactive({ active: t === "open" }), la = {
  open: !0,
  close: !1,
  toggle: null
}, ua = (e, t, { modifiers: [r = "toggle"] }, { Alpine: n }) => {
  n.bind(t, {
    "x-on:click": () => {
      e.active = la[r] ?? !e.active;
    },
    ":aria-expanded": () => e.active
  });
}, da = (e, t, r, { Alpine: n }) => {
  n.bind(t, { "x-show": () => e.active });
}, fa = {
  control: ua,
  container: da
}, ha = at("accordion", ca, fa), va = (e) => {
  sa(e), ha(e);
}, Rt = new ResizeObserver((e) => {
  for (const t of e) {
    const r = t.target;
    r instanceof HTMLElement && pa(r);
  }
}), pa = async (e) => {
  await be.nextTick(), e.scrollLeft = (e.scrollWidth - e.clientWidth) / 2, e.scrollTop = (e.scrollHeight - e.clientHeight) / 2;
}, Dt = Array.prototype.forEach, ma = (e) => e.directive("dragscroll", (t, { modifiers: r }, { cleanup: n }) => {
  const i = r.includes("center");
  n(ga(t)), t.classList.add("overscroll-contain", "cursor-grab"), i && (Dt.call(t.children, (a) => Rt.observe(a)), n(() => Dt.call(t.children, (a) => Rt.unobserve(a))));
}), de = (e) => {
  e.preventDefault(), e.stopPropagation();
}, $t = [
  "pointerup",
  "mouseup",
  "touchend"
], ga = (e) => {
  const t = (i) => {
    de(i), e.scrollLeft -= i.movementX, e.scrollTop -= i.movementY;
  }, r = async (i) => {
    de(i), document.removeEventListener("pointermove", t, !0), document.body.classList.remove("!cursor-grabbing", "[&>*]:pointer-events-none"), e.classList.add("cursor-grab"), await be.nextTick(), document.removeEventListener("click", de, !0), $t.forEach((a) => document.removeEventListener(a, r, { capture: !0 }));
  }, n = (i) => {
    ba(i) || i.button !== 2 && (de(i), e.classList.remove("cursor-grab"), document.body.classList.add("!cursor-grabbing", "[&>*]:pointer-events-none"), document.addEventListener("pointermove", t, { capture: !0 }), $t.forEach((a) => document.addEventListener(a, r, { capture: !0 })), document.addEventListener("click", de, { capture: !0 }));
  };
  return e.addEventListener("pointerdown", n), () => e.removeEventListener("pointerdown", n);
}, ba = (e) => e instanceof TouchEvent || e instanceof PointerEvent && e.pointerType === "touch", ya = (e, t, { Alpine: r }) => {
  const n = r.reactive({
    root: e,
    isOpen: !1,
    open() {
      this.isOpen = !0;
    },
    close() {
      this.isOpen = !1;
    },
    toggle() {
      return this.isOpen ? this.close() : this.open();
    }
  });
  return r.bind(e, { "x-id": () => ["x-panel"] }), n;
}, wa = at("panel", ya, {
  summary: (e, t, r, { Alpine: n }) => {
    n.bind(t, {
      ":aria-expanded": () => e.isOpen,
      ":aria-controls": '$id("x-panel")'
    });
  },
  content: (e, t, r, { Alpine: n }) => {
    n.bind(t, {
      "x-show": () => e.isOpen,
      ":id": '$id("x-panel")'
    });
  }
}), xa = at("tabs", (e, t, { Alpine: r, evaluate: n }) => r.reactive({
  activeTab: 0,
  isSelected(i) {
    return this.tabs[this.activeTab] === i;
  },
  tabs: [],
  panels: [],
  $focus: n("$focus")
}), {
  list: (e, t, r, { Alpine: n }) => {
    const i = () => e.$focus.wrap().next(), a = () => e.$focus.wrap().previous();
    n.bind(t, {
      ":role": () => "tablist",
      "@keydown.arrow-left.stop.prevent": a,
      "@keydown.arrow-right.stop.prevent": i,
      "@keydown.arrow-up.stop.prevent": a,
      "@keydown.arrow-down.stop.prevent": i
    });
  },
  tab: (e, t, r, { Alpine: n }) => {
    const i = e.tabs.push(t) - 1, a = () => e.activeTab = i;
    n.bind(t, {
      ":tabindex": () => +(i === e.activeTab) - 1,
      ":aria-selected": () => i === e.activeTab,
      "@click": a,
      "@keydown.space.stop.prevent": a,
      "@keydown.enter.stop.prevent": a
    });
  },
  panel: (e, t, r, { Alpine: n }) => {
    const i = e.panels.push(t) - 1;
    n.bind(t, {
      ":tab-index": () => i !== e.activeTab ? -1 : 0,
      ":aria-hidden": () => i !== e.activeTab,
      ":class"() {
        if (i === e.activeTab) return "panel-current";
        if (i > e.activeTab) return "panel-next";
        if (i < e.activeTab) return "panel-previous";
      }
    });
  }
}), me;
(function(e) {
  e[e.None = 0] = "None", e[e.Left = 1] = "Left", e[e.Right = 2] = "Right", e[e.Up = 4] = "Up", e[e.Down = 8] = "Down";
})(me || (me = {}));
var ge = /* @__PURE__ */ new WeakMap(), Ea = ge.has.bind(ge), Sa = (e) => e.directive("swipe", (t, r, { cleanup: n }) => {
  ge.set(t, { dispatch: (i) => {
    const a = Object.entries(me).filter(([, o]) => typeof o == "number" && o && (i & o) === o).map(([o]) => o.toLowerCase());
    t.dispatchEvent(new CustomEvent("swipe", { detail: a.join("-") })), t.dispatchEvent(new CustomEvent(`swipe${a.join("")}`, { detail: a.join("-") }));
  } }), t.addEventListener("touchstart", Pt), n(() => t.removeEventListener("touchstart", Pt));
}), Pt = (e) => {
  const t = ge.get(e.currentTarget);
  if (!t) return;
  const { clientX: r, clientY: n } = e.touches[0];
  t.start ??= {
    x: r,
    y: n
  }, document.addEventListener("touchend", Ta, { once: !0 });
}, Ta = (e) => {
  const t = e.target;
  if (!t) return;
  const r = ge.get(mr(t, Ea));
  if (!r?.start) return;
  const { clientX: n, clientY: i } = e.changedTouches[0], a = ka(r.start, {
    x: n,
    y: i
  });
  a !== me.None && (r.dispatch(a), delete r.start);
}, mr = (e, t) => t(e) ? e : e.parentElement ? mr(e.parentElement, t) : null, ka = (e, t) => {
  const r = [t.x - e.x, t.y - e.y];
  if (r.every((o) => Math.abs(o) < 50)) return me.None;
  const n = Math.sqrt(r[0] * r[0] + r[1] * r[1]), [i, a] = r.map((o) => o / n);
  return Mt(i) | Mt(a) << 2;
}, Mt = (e) => e > 0.5 ? 2 : e < -0.5 ? 1 : 0, Na = (e) => {
  e.magic("screen", () => (t) => {
    const r = typeof t == "number" ? t : Oa[t] ?? Number(t);
    return r ? Ca(r, e).value : (console.error(`Invalid breakpoint: $screen(${JSON.stringify(t)})`), !1);
  });
}, Oa = {
  xs: 320,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
}, gr = {}, Ca = (e, t) => gr[e] ?? _a(e, t), _a = (e, t) => {
  const r = window.matchMedia(`(min-width: ${e}px)`), n = t.reactive({ value: r.matches });
  return gr[e] = n, r.addEventListener("change", (i) => {
    n.value = i.matches;
  }), n;
}, Aa = (e) => e.plugin([Na]), Fa = (e) => e.plugin([
  va,
  ma,
  wa,
  Sa,
  xa,
  Aa
]), Ia = (e) => {
  e.bind("hideOverflow", {
    "x-data": "{ visible: true }",
    ":class": "{ 'pointer-events-none invisible': !visible }",
    "x-intersect:leave.threshold.99.margin.1000.0": "visible = false",
    "x-intersect:enter.threshold.99.margin.1000.0": "visible = true"
  });
}, La = (e) => {
  e.directive("inert-trap", (t, { expression: r, modifiers: n }, { evaluateLater: i, effect: a }) => {
    const o = n.includes("retain"), s = n.includes("noscroll"), c = n.includes("return"), l = i(r), h = [];
    let u = null;
    a(() => {
      l((v) => {
        if (v) {
          u = document.activeElement;
          for (const p of Ra(t, ...document.querySelectorAll("[role=alertdialog]"), o ? u?.closest("[data-retain-focus-from]") ?? u : null))
            p.setAttribute("inert", "inert"), h.push(p);
          s && document.documentElement.style.setProperty("overflow", "hidden");
        } else {
          for (const p of h) p.removeAttribute("inert");
          h.length = 0, s && document.documentElement.style.removeProperty("overflow"), c && u && (u.focus(), u = null);
        }
      });
    });
  });
};
function Ra(...e) {
  return e = e.filter((t) => t !== null), document.createTreeWalker(document.body, NodeFilter.SHOW_ELEMENT, (t) => {
    if (!(t instanceof HTMLElement) || t.matches("[inert] > *") || e.includes(t)) return NodeFilter.FILTER_REJECT;
    for (const r of e) if (t.contains(r)) return NodeFilter.FILTER_SKIP;
    return NodeFilter.FILTER_ACCEPT;
  });
}
TreeWalker.prototype[Symbol.iterator] ??= function* () {
  let e = this.nextNode();
  for (; e; )
    yield e, e = this.nextNode();
};
var Da = (e) => {
  e.directive("highlight-scroll", (t, { expression: r }, { cleanup: n }) => {
    const i = r.trim();
    if (!i) {
      console.warn("Alpine.js: v-highlight-scroll requires a class name to highlight.");
      return;
    }
    const a = t.firstChild;
    if (!a || !(a instanceof Text)) {
      console.warn("Alpine.js: v-highlight-scroll requires a text node as the first child.");
      return;
    }
    const o = (a.textContent?.trim().split("") ?? []).map((l) => {
      const h = document.createElement("span");
      return h.textContent = l, h.classList.add(i), h;
    });
    a.replaceWith(...o);
    let s = -1;
    const c = setInterval(() => {
      s == -1 ? o.forEach((l) => l.classList.remove(i)) : o[s]?.classList.remove(i), s += 1, s %= o.length, o[s]?.classList.add(i);
    }, 500);
    n(() => clearInterval(c));
  }), e.addInitSelector(() => e.prefixed("highlight-scroll"));
}, $a = [
  Bn,
  Bi,
  Hi,
  qn,
  yi,
  La,
  Ti,
  Ia,
  Fi,
  Mi({
    shopify: !0,
    autoSize: !0
  }),
  Fa,
  Da,
  ea,
  ra,
  qi,
  (e) => {
    e.magic("dataset", (t) => t.dataset), e.magic("formatMoney", () => et);
  }
], Pa = (e) => e.store("mobileMenu", {
  visible: !1,
  show() {
    this.visible = !0;
  },
  hide() {
    this.visible = !1;
  },
  toggle() {
    this.visible = !this.visible;
  }
}), Ma = (e) => e.store("modal", {
  isOpen: !1,
  open() {
    this.isOpen = !0;
  },
  close() {
    this.isOpen = !1;
  }
}), ja = (e) => {
  e.store("search", {
    openState: !1,
    get isOpen() {
      return window.location.pathname !== "/search" && this.openState;
    },
    set isOpen(t) {
      this.openState = t;
    },
    query: "",
    get searchUrl() {
      const t = new URL("/search", window.location.origin);
      return t.search = new URLSearchParams({
        q: this.query,
        type: "product"
      }).toString(), t;
    }
  });
}, Ba = [
  Mr,
  Pa,
  Ma,
  ja
];
be.plugin([
  ...$a,
  ...Ba,
  ...on
]);
window.Alpine = be;
var Ha = be, za = Ha;
export {
  za as default
};
